<template>
  <div class="debug">
    <h2>调试页面</h2>
    <!-- <button @click="sortSaleByActiveScore">分享点赞榜</button> -->
    <button @click="hvhlshalefs">我是按钮</button>
    <button @click="hvalsefvase">debug</button>
    <button @click="xhfaxhfaefae">删除自己人的动态</button>
    <button @click="dhxefsef">更新周边新房二手房</button>
    <button @click="momentFail">加积分失败</button>
    <button @click="findFakeInvite">查看刷分情况</button>
    <!-- <input type="file" @change="xfhalefaef"> -->
    <!-- <input type="text" @keydown.enter="parseBuilding" v-model="testBuilding"> -->
    <input type="text" @keydown.enter="setRegister" placeholder="更新意向登记">
    <input type="text" v-model="sell_id" placeholder="更新意向登记id">
    <!-- <input type="text" @keydown.enter="setRegister" placeholder="更新意向登记"> -->
    <input type="text" @keydown.enter="setRandom" placeholder="更新摇号结果">
    <div class="normal">
      <input type="text" placeholder="客户端" v-model="client">
      <input type="text" placeholder="账号" v-model="userName">
      <input type="text" placeholder="密码" v-model="passwd">
      <input type="text" placeholder="真实姓名" v-model="fullName">
      <input type="text" placeholder="身份" v-model="userType">
      <input type="text" placeholder="群组" v-model="group">
      <input type="text" placeholder="城市" v-model="userCity">
      <input type="text" placeholder="电话" v-model="phone">
      <input type="text" placeholder="虚拟号" v-model="phonex">
      <input type="text" placeholder="小程序id" v-model="mp_uid">
      <input type="text" placeholder="开发项目" v-model="project">
      <button @click="addManageUser">添加</button>
    </div>
    <!-- 房贷计算 -->
    <!-- <div>
      <div>贷款金额：<input type="text" v-model="money">万</div>
      <div>贷款年限：<input type="text" v-model="year">年</div>
      <div>还款方式：
        <select v-model="pay_way">
          <option value="等额本息">等额本息</option>
          <option value="等额本金">等额本金</option>
        </select>
      </div>
    </div> -->
    <!-- <img :src="tempImage" alt="" preview="3"> -->
    <!-- 销售分享点赞排名 -->
    <div class="sales" v-if="sales.length > 0">
      <div v-for="(sale, index) in sales" :key="index" class="sale">
        <img :src="sale.head_url" preview="3" :preview-text="sale.user_name">
        <div>{{sale.user_name}}</div>
        <div>{{sale.real_estate_name}}</div>
        <div>
          <span>关注数:{{sale.gz}}</span>
          <!-- <span>分享:{{sale.share_num}}</span>
          <span>点赞:{{sale.praise_num}}</span>
          <span>总计:{{sale.praise_num + sale.share_num}}</span> -->
        </div>
      </div>
    </div>

    <!-- <div class="colorline" v-if="minutesList.length > 0">
      <div v-for="(num,index) in minutesList" :key="index" :style="{'background-color':colorMap[num]||'#eeeeee','display':'inline-block','width':'8px','height':'30px'}">{{num || ''}}</div>
    </div>
    <div>
      <div v-for="(color,index) in colorMap" :key="index" :style="{'background-color':color,width:'50px', height:'30px'}">{{index}}</div>
    </div> -->

    <div v-if="backUsers.length" style="padding: 0 50px;">
      <el-table :data="backUsers" border stripe>
        <el-table-column prop="id" label="id">
        </el-table-column>
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <el-table-column prop="userName" label="账号">
        </el-table-column>
        <el-table-column prop="city" label="城市">
        </el-table-column>
        <el-table-column prop="group" label="小队">
        </el-table-column>
        <el-table-column prop="userType" label="身份">
        </el-table-column>
        <el-table-column prop="passwd" label="密码">
        </el-table-column>
        <el-table-column prop="project" label="开发项目">
        </el-table-column>
        <el-table-column prop="mp_uid" label="小程序id">
        </el-table-column>
        <el-table-column prop="phone" label="电话">
        </el-table-column>
        <el-table-column prop="phonex" label="虚拟号">
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        real_id: '',
        desList: [],
        imgSrc: '',
        currentTime: '',
        areaList: [],
        locationList: [], // 除了学区范围, 地铁线路, 地铁站 之外的其它配套
        realList: [],
        oldRealList: [],
        apartmentDataList: [],
        subwayList: [], // 地铁线路
        currentTime: '',
        sales: [],
        pay_way: '等额本息',
        year: '',
        money: '',

        start_id: '',
        end_id: '',

        listType: '',
        showRealList: [],
        areaSort: {
          '上城区': 20,
          '下城区': 19,
          '江干区': 18,
          '拱墅区': 17,
          '西湖区': 16,
          '滨江区': 15,
          '钱塘新区': 14,
          '萧山区': 13,
          '余杭区': 12,
          '富阳区': 11,
          '临安区': 10
        },
        dialogVisible: false,
        daoguaPrice: '',
        editIndex: -1,

        stationList: [], // 地铁站列表

        chooseHouse: null,

        tempImage: '',

        testBuilding: '',

        minutesList: [],
        colorMap: {
          '1': '#cccccc',
          '2': '#999999',
          '3': '#666666',
          '4': '#333333',
          '5': '#000000',
        },

        placeSearch: null,

        schoolBindRealList: [],

        userName: '',
        passwd: '',
        fullName: '',
        userType: '',
        group: '',
        userCity: '',
        phone: '',
        phonex: '',
        mp_uid: '',
        project: '',

        sell_id: '',
        client: '',

        backUsers: [],
      }
    },
    mounted() {
      this.init()
      this.$close();
    },
    methods: {
      init() {
        let that = this;

        // that.$open();

        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpAreaModel'
        //   }
        // }).then(function (res) {
        //   console.log('所有板块', res)
        //   that.areaList = res.data.data
        //   that.$close()
        // })

        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpLocationModel',
        //     projection: 'id location_name lnglat location_type school_type location_degree subway_station location_level location_size area_id start'
        //   }
        // }).then(function (res) {
        //   console.log('所有地段', res)
        //   let list = res.data.data;
        //   // that.locationList = list;
        //   for (let i = 0; i < list.length; i++) {
        //     if (list[i].school_type === '地铁') {
        //       that.stationList.push(list[i])
        //     } else {
        //       that.locationList.push(list[i])
        //     }
        //   }
        //   that.$close()
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'SubwayModel',
        //   }
        // }).then(function (res) {
        //   console.log('地铁线', res)
        //   that.subwayList = res.data.data.filter(x => x.stage == '三期');
        //   that.$close()
        // })

        // that.$axios.get(that.$url_prefix + 'queryApartmentList').then(function (res) {
        //   that.$close()
        //   console.log('所有户型数据', res)
        //   that.apartmentDataList = res.data.data
        // })
        // that.$axios.get(that.$url_prefix + 'getNewReals').then(function (res) {
        //   console.log('所有新房', res)
        //   that.realList = res.data.data
        //   that.$close()
        // })
        // that.$axios.get(that.$url_prefix + 'getOldReals').then(function (res) {
        //   console.log('所有二手', res)
        //   that.oldRealList = res.data.data
        //   that.$close()
        // })
        // that.$axios.get(that.$url_prefix + 'queryOneById', {
        //   params: {
        //     id: '1884jgyw2tu',
        //     db: 'WpBackupModel'
        //   }
        // }).then(function (res) {
        //   console.log('选房系数', res)
        //   that.chooseHouse = JSON.parse(res.data.data.data);
        //   that.$close()
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpAreaModel',
        //     projection: 'id level area_name'
        //   }
        // }).then(function (res) {
        //   that.areaList = res.data.data;
        //   console.log('that.areaList', that.areaList);
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpRegisterModel',
        //   }
        // }).then(function (res) {
        //   console.log('list', res.data.data);

        // })
      },

      momentFail() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'momentFail').then(res => {
          console.log('back', res);
        })
      },

      findFakeInvite() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'findFakeInvite').then(res => {
          console.log('back', res);
        })
      },

      dhxefsef() { // 更新周边新房二手房
        let that = this;
        that.$axios.get(that.$url_prefix + 'setNear').then(res => {
          console.log('update back');
        })
      },

      updateAreaTrend() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'updateAreaTrend').then(res => {
          console.log('update back');
        })
      },

      // 检查有哪些地段没有路径,没有路径的就解绑
      check() {
        let that = this;
        that.$open();
        let list = JSON.parse(JSON.stringify(this.realList)); //所有楼盘
        this.checkR(list);
      },
      checkR(list) {
        let that = this;
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        that.$axios.get(that.$url_prefix + 'withoutPath', {
          params: {
            real_estate_id: theOne.id
          }
        }).then(function (res) {
          if (res.data.data.errLocationList.length > 0) {
            let errorList = res.data.data.errLocationList
            let obj = res.data.data.realEstate
            that.checkS(errorList, obj.id, list);
          } else {
            that.checkR(list);
            return;
          }
        }).catch(function (res) {
          console.log('withoutPath fail', res);
          that.checkR(list);
          return;
        })
      },
      checkS(errList, id, checkList) {
        let that = this;
        if (errList.length === 0) {
          that.checkR(checkList);
          return;
        }
        let theOne = errList.splice(0, 1)[0];
        let reals = theOne.real_estates.filter(x => x !== id);

        let ele = {
          id: theOne.id,
          real_estates: reals
        }
        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(ele)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.checkS(errList, id, checkList);
        }).catch(function (res) {
          console.log('更新地段错误', res)
          that.checkS(errList, id, checkList);
        })
      },

      getAreaNameObj() { // 板块分类对象
        let that = this
        if (that.areaList.length === 0) {
          return false;
        }
        let baseList = JSON.parse(JSON.stringify(that.areaList))
        let list = []
        let obj = {}
        for (let i = 0; i < baseList.length; i++) {
          if (!baseList[i].district) {
            continue
          }
          if (list.indexOf(baseList[i].district) === -1) {
            list.push(baseList[i].district)
            obj[baseList[i].district] = [baseList[i].area_name]
          } else {
            obj[baseList[i].district].push(baseList[i].area_name)
          }
        }
        let obbj = {
          id: '2jvrd2zen4k',
          data: JSON.stringify(obj)
        }
        // console.log('obj', obj);
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obbj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新板块分类对象返回', res)
        }).catch(function (res) {
          console.log('更新板块分类对象失败', res)
        })
      },

      // 看哪些楼盘画了户型图
      temp3() {
        let that = this
        let id_list = []
        let id_obj = {}
        for (let i = 0; i < res.data.data.length; i++) {
          if (id_list.indexOf(res.data.data[i].real_estate_id) === -1) {
            id_list.push(res.data.data[i].real_estate_id)
            id_obj[res.data.data[i].real_estate_name] = [res.data.data[i].serial_number]
          } else {
            id_obj[res.data.data[i].real_estate_name].push(res.data.data[i].serial_number)
          }
        }
        console.log(id_obj)
      },

      // 判断某个坐标是哪个板块的
      judgeArea(pos) {
        let that = this
        for (let k = 0; k < that.areaList.length; k++) {
          if (that.areaList[k].dots) {
            let temp = that.areaList[k].dots.split('-')
            for (let i = 0; i < temp.length; i++) {
              temp[i] = temp[i].split('|')
            }
            if (AMap.GeometryUtil.isPointInRing(pos, temp)) {
              return that.areaList[k]
            }
          }
        }
        return false
      },

      // 给所有地段绑定板块, 要改改, 不需要全部数据都上传
      temp10() {
        let that = this
        that.$open();
        let list = JSON.parse(JSON.stringify(this.locationList))
        that.temp12(list)
      },
      temp12(list) {
        let that = this
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0]
        if (!theOne.lnglat) {
          console.log('没有经纬度', theOne)
          that.temp12(list)
          return
        }
        let dot = theOne.lnglat.split('-')[0].split('|')
        let result = that.judgeArea(dot)
        if (!result) {
          that.temp12(list)
          return
        }
        if (result.id === theOne.area_id) {
          that.temp12(list)
          return
        }
        theOne.area_id = result.id
        theOne.area_name = result.area_name
        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(theOne)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp12(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp12(list)
        })
      },

      // 统计板块内的地铁、商场等的数量, 查找周边板块
      temp14() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryAreaByLevel', {
          params: {
            level: '板块',
            projection: '-_id id dots'
          }
        }).then(res => {
          that.$open();
          // console.log('所有板块', res);
          that.temp15(res.data.data);
        })
      },
      temp15(list) {
        let that = this
        if (list.length === 0) {
          that.$close();
          return
        }
        let theOne = list.splice(0, 1)[0]

        // 板块面积
        let path = theOne.dots.split('-').map(x => {
          return x.split('|');
        });
        let square = Math.round(AMap.GeometryUtil.ringArea(path) / 10000);

        //统计地段商场等的数量
        let station = 0,
          subway = [],
          shop = 0,
          shop_square = 0,
          shop_square_t = 0,
          office_square = 0,
          office = 0,
          want = ['商场', '办公', '交通'];
        for (let i = 0; i < this.locationList.length; i++) {
          let oneLoc = this.locationList[i]
          if (oneLoc.area_id !== theOne.id) {
            continue
          }
          if (want.indexOf(oneLoc.location_type) === -1) {
            continue
          }
          if (!oneLoc.lnglat) {
            continue
          }
          if (oneLoc.location_type === '商场') {
            shop++;
            shop_square += (parseInt(oneLoc.location_size) || 0);
            shop_square_t += (parseInt(oneLoc.location_level) || 0);
          } else if (oneLoc.location_type === '办公') {
            office++;
            office_square += (parseInt(oneLoc.location_level) || 0);
          } else if (oneLoc.school_type === '地铁') {
            station++;
            let subways = oneLoc.subway_station.split('|')
            for (let k = 0; k < subways.length; k++) {
              if (subway.indexOf(subways[k]) === -1) {
                subway.push(subways[k])
              }
            }
          }
        }
        let obj = {}
        if (shop > 0) {
          obj.market_n = shop;
          obj.market_s = shop_square;
          obj.market_ts = shop_square_t;
        }

        if (office > 0) {
          obj.office_n = office;
          obj.office_ts = office_square;
        }
        if (station > 0) {
          let snum = subway.length;
          obj.subway = snum + '条地铁线路：' + subway.join('，');
          obj.station = station
        }

        if (JSON.stringify(obj) === '{}') {
          that.temp15(list)
          return
        }

        console.log(square, obj);
        // that.temp15(list);
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify({
            id: theOne.id,
            contain: obj,
            space: square + '万方'
          })
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp15(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp15(list)
        })
      },
      temp15fszefef(list) {
        let that = this
        if (list.length === 0) {
          that.$close();
          return
        }
        let theOne = list.splice(0, 1)[0]
        let theOneDots = theOne.dots.split('-')
        //查找周边板块
        let nearArea = []
        for (let i = 0; i < this.areaList.length; i++) {
          let thatOne = this.areaList[i]
          if (thatOne.id === theOne.id) {
            continue
          }
          if (!thatOne.dots) {
            continue
          }
          let thatOneDots = thatOne.dots.split('-')
          for (let k = 0; k < theOneDots.length; k++) {
            if (thatOneDots.indexOf(theOneDots[k]) > -1) {
              if (thatOne.average_price) {
                let price = JSON.parse(thatOne.average_price).first
                let minPrice = 100000000
                for (let key in price) {
                  if (price[key] < minPrice) {
                    minPrice = price[key]
                  }
                }
                nearArea.push({
                  area_name: thatOne.area_name,
                  average_price: minPrice,
                  center: thatOne.center
                })
              }
              break
            }
          }

        }
        //统计地段商场等的数量
        let station = 0,
          subway = [],
          shop = 0,
          shop_square = 0,
          office_square = 0,
          office = 0,
          want = ['商场', '办公', '交通'];
        for (let i = 0; i < this.locationList.length; i++) {
          let oneLoc = this.locationList[i]
          if (oneLoc.area_id !== theOne.id) {
            continue
          }
          if (want.indexOf(oneLoc.location_type) === -1) {
            continue
          }
          if (!oneLoc.lnglat) {
            continue
          }
          if (oneLoc.location_type === '商场') {
            shop++;
            shop_square += (parseInt(oneLoc.location_level) || 0);
          } else if (oneLoc.location_type === '办公') {
            office++;
            office_square += (parseInt(oneLoc.location_level) || 0);
          } else if (oneLoc.school_type === '地铁') {
            station++;
            let subways = oneLoc.subway_station.split('|')
            for (let k = 0; k < subways.length; k++) {
              if (subway.indexOf(subways[k]) === -1) {
                subway.push(subways[k])
              }
            }
          }
        }
        let obj = {}
        if (shop > 0) {
          obj.shopping_mall = shop + '个购物中心' + shop_square + '万方';
        }

        if (office > 0) {
          obj.office_building = office + '个办公楼' + office_square + '万方';
        }
        if (station > 0) {
          obj.traffic = subway.length + '条地铁线' + '(' + subway.join('|') + ')' + ' ' + station + '个站点'
        }
        if (nearArea.length > 0) {
          obj.near_area = JSON.stringify(nearArea)
        } else {
          obj.near_area = ''
        }
        if (JSON.stringify(obj) === '{}') {
          that.temp15(list)
          return
        }
        obj.id = theOne.id
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp15(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp15(list)
        })
      },

      // 计算板块内新房楼盘均价
      temp16() {
        console.log('点击')
        let that = this
        that.$open();
        that.$axios.get(that.$url_prefix + 'getNewReals', {
          params: {
            project: '-_id id real_estate_name area_id piece'
          }
        }).then((res) => {
          that.realList = res.data.data;
          that.$axios.get(that.$url_prefix + 'queryAreaByLevel', {
            params: {
              level: '板块',
              projection: '-_id id area_name'
            }
          }).then(function (res) {
            that.temp17(res.data.data);
          }).catch((res) => {
            console.log('get area fail', res);
          })
        }).catch((res) => {
          console.log('get reals fail', res);
        })
      },
      temp17(list) {
        let that = this
        if (list.length === 0) {
          that.$close()
          return
        }
        let theOne = list.splice(0, 1)[0]
        let realList = that.realList.filter((ele) => {
          if (ele.area_id === theOne.id) {
            return true;
          }
        })
        let average_price = '';
        let priceObj = {
          '高层': {
            num: 0,
            price: 0
          },
          '洋房': {
            num: 0,
            price: 0
          },
          '排屋': {
            num: 0,
            price: 0
          },
          '合院': {
            num: 0,
            price: 0
          },
          '别墅': {
            num: 0,
            price: 0
          },
        }
        let price = {}
        realList.forEach((ele) => {
          for (let i = 0; i < ele.piece.length; i++) {
            let price = parseInt(ele.piece[i].price);
            if (priceObj[ele.piece[i].type]) {
              if (price < 10000 || price > 100000) {
                console.log('价格异常', ele);
              } else {
                priceObj[ele.piece[i].type].num++;
                priceObj[ele.piece[i].type].price += price;
              }
            }
          }
        })
        if (priceObj['高层'].num > 0) {
          price['高层'] = Math.round(priceObj['高层'].price / priceObj['高层'].num)
        }
        if (priceObj['洋房'].num > 0) {
          price['洋房'] = Math.round(priceObj['洋房'].price / priceObj['洋房'].num)
        }
        if (priceObj['排屋'].num > 0) {
          price['排屋'] = Math.round(priceObj['排屋'].price / priceObj['排屋'].num)
        }
        if (priceObj['合院'].num > 0) {
          price['合院'] = Math.round(priceObj['合院'].price / priceObj['合院'].num)
        }
        if (priceObj['别墅'].num > 0) {
          price['别墅'] = Math.round(priceObj['别墅'].price / priceObj['别墅'].num)
        }
        if (JSON.stringify(price) !== '{}') {
          average_price = JSON.stringify({
            first: price
          })
        }
        let minPrice = 100000000
        for (let key in price) {
          let pp = parseInt(price[key])
          if (pp && pp < minPrice) {
            minPrice = price[key]
          }
        }
        let obj = {
          id: theOne.id,
          average_price: average_price,
          new_price: minPrice < 100000000 ? minPrice : ''
        }
        console.log(theOne.area_name, obj)
        // that.temp17(list)
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp17(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp17(list)
        })
      },

      // 计算板块内二手房楼盘均价
      temp11116() {
        console.log('点击')
        let that = this
        that.$open();
        that.$axios.get(that.$url_prefix + 'getOldReals').then((res) => {
          that.oldRealList = res.data.data;
          that.$axios.get(that.$url_prefix + 'queryAreaByLevel', {
            params: {
              level: '板块',
              projection: '-_id id area_name'
            }
          }).then(function (res) {
            that.temp11117(res.data.data);
          }).catch((res) => {
            console.log('get area fail', res);
          })
        }).catch((res) => {
          console.log('get reals fail', res);
        })
      },
      temp11117(list) {
        let that = this
        if (list.length === 0) {
          that.$close()
          return
        }
        let theOne = list.splice(0, 1)[0]
        let realList = that.oldRealList.filter((ele) => {
          if (ele.price && ele.area_id === theOne.id) {
            return true;
          }
        })

        let price = 0;
        let num = 0;
        realList.forEach((ele) => {
          let tempP = parseInt(ele.price)
          if (tempP > 0) {
            price += tempP
            num++
          }
        })

        let old_price = ''
        if (num > 0) {
          old_price = (price / num).toFixed(0)
        }

        let obj = {
          id: theOne.id,
          old_price: old_price
        }
        console.log(obj)
        // that.temp11117(list)
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp11117(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp11117(list)
        })
      },

      // 计算击败多少板块
      temp34() {
        let list = JSON.parse(JSON.stringify(this.areaList))
        let priceList = []
        for (let i = 0; i < list.length; i++) {
          let subway = list[i].traffic || ''
          let office = list[i].office_building || ''
          let shop = list[i].shopping_mall || ''
          if (subway) {
            list[i].line_num = parseInt(subway)
            list[i].station_num = parseInt(subway.split(' ')[1])
          } else {
            list[i].line_num = 0
            list[i].station_num = 0
          }
          if (office) {
            if (office.indexOf(' ') > -1) {
              list[i].office_num = parseInt(office) + parseInt(office.split(' ')[1])
            } else {
              list[i].office_num = parseInt(office)
            }
          } else {
            list[i].office_num = 0
          }
          if (shop) {
            list[i].shopping_num = parseInt(shop)
          } else {
            list[i].shopping_num = 0
          }
          if (list[i].average_price) {
            let price = JSON.parse(list[i].average_price).first
            let minPrice = 100000000
            for (let key in price) {
              if (price[key] < minPrice) {
                minPrice = price[key]
              }
            }
            list[i].price = minPrice
            priceList.push(list[i])
          }
        }
        this.$store.commit('SET_IS_LOADING', true)
        let arr = list.slice(0)
        this.temp35(list, arr, priceList)
      },
      temp35(list, arr, priceList) {
        let that = this
        if (list.length === 0) {
          that.$store.commit('SET_IS_LOADING', false)
          return
        }
        let theOne = list.splice(0, 1)[0]
        let beatsub = 0
        let beatoffice = 0
        let beatshopping = 0
        for (let i = 0; i < arr.length; i++) {
          if (theOne.line_num > arr[i].line_num) {
            beatsub++
          } else if (theOne.line_num === arr[i].line_num && theOne.station_num > arr[i].station_num) {
            beatsub++
          }
          if (theOne.office_num > arr[i].office_num) {
            beatoffice++
          }
          if (theOne.shopping_num > arr[i].shopping_num) {
            beatshopping++
          }
        }
        let compare = {
          subway: Math.round((beatsub / arr.length) * 100),
          office: Math.round((beatoffice / arr.length) * 100),
          shopping: Math.round((beatshopping / arr.length) * 100)
        }
        if (theOne.price) {
          let beatprice = 0
          for (let i = 0; i < priceList.length; i++) {
            if (theOne.price < priceList[i].price) {
              beatprice++
            }
          }
          compare.price = Math.round((beatprice / priceList.length) * 100)
        }
        let obj = {
          id: theOne.id,
          compare: JSON.stringify(compare)
        }
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp35(list, arr, priceList)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp35(list, arr, priceList)
        })
      },

      mapStation() { //对应地铁站
        let that = this;
        that.$axios.get(that.$url_prefix + 'getSubwayAndStation').then((res) => {
          let subway = res.data.subway;
          let loc_station = res.data.station;
          let idList = [];
          for (let i = 0; i < subway.length; i++) {
            let subway_station = JSON.parse(subway[i].station);
            let lineName = subway[i].name;
            for (let j = 0; j < subway_station.length; j++) {
              let oneStation = subway_station[j]
              oneStation.index = j
              oneStation.line = lineName;
              delete oneStation.goto
              delete oneStation.id
              for (let k = 0; k < loc_station.length; k++) {
                if (loc_station[k].location_name === oneStation.name && loc_station[k].subway_station.indexOf(
                    lineName) > -1) {
                  oneStation.id = loc_station[k].id
                  if (!idList.includes(oneStation.id)) {
                    idList.push(oneStation.id);
                  }
                  if (loc_station[k].subway_station.indexOf('|') > -1) {
                    oneStation.goto = loc_station[k].subway_station.split('|').filter(x => x !== lineName).join('|')
                  }
                  if (loc_station[k].new_lnglat) {
                    loc_station[k].new_lnglat += ('-' + oneStation.position.join('|'));
                  } else {
                    loc_station[k].new_lnglat = oneStation.position.join('|');
                  }
                  break;
                }
              }
              if (!oneStation.id) {
                console.log('no match', lineName, oneStation.name);
              }
            }
            subway[i].station = subway_station;
          }
          console.log('idList.length', idList.length);
          console.log('subway', subway)
          console.log('loc_station', loc_station)
          let diffLnglat = loc_station.filter((x) => {
            return x.lnglat !== x.new_lnglat;
          });
          console.log('diffLnglat', diffLnglat);
          // this.$open();
          // this.updateStation(diffLnglat);
          // this.updateSubway(subway);
        }).catch((res) => {
          console.log('get subway fail', res);
        })
      },
      updateSubway(list) { // 更新线路信息
        let that = this;
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let obj = {
          id: theOne.id,
          station: JSON.stringify(theOne.station)
        }
        let param = {
          'db': 'SubwayModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('update subway back', res)
          that.updateSubway(list);
        }).catch(function (res) {
          that.updateSubway(list);
          console.log('update subway fail', res)
        })
      },
      updateStation(list) { // 更新地铁站信息，目前是更新经纬度
        let that = this;
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let obj = {
          id: theOne.id,
          lnglat: theOne.new_lnglat
        }
        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('update station back', res)
          that.updateStation(list);
        }).catch(function (res) {
          that.updateStation(list);
          console.log('update station fail', res)
        })
      },

      // 计算地铁的换乘时间
      temp22() {
        let that = this
        //首先知道起始站和终点站的id
        let start_id = 'eq9p93tkk'
        let end_id = '2je1b3ned20'

        if (start_id === end_id) {
          alert('同一个站！')
          return false;
        }

        let subwayObj = {}
        let startList = []
        let endList = []
        for (let i = 0; i < that.subwayList.length; i++) {
          let lineStations = JSON.parse(that.subwayList[i].station);
          subwayObj[that.subwayList[i].name] = lineStations
          for (let j = 0; j < lineStations.length; j++) {
            if (lineStations[j].id === start_id) {
              lineStations[j].subway = that.subwayList[i].name
              startList.push(lineStations[j])
            } else if (lineStations[j].id === end_id) {
              lineStations[j].subway = that.subwayList[i].name
              endList.push(lineStations[j])
            }
          }
        }

        // console.log('subwayObj', subwayObj)

        let plans = []
        for (let m = 0; m < startList.length; m++) {
          for (let n = 0; n < endList.length; n++) {
            let plan = {}
            plan.start = startList[m]
            plan.end = endList[n]
            if (plan.start.subway === plan.end.subway) {
              //起点。终点在同一条线路中
              plan.path = []
              if (plan.start.index > plan.end.index) {
                plan.path.push({
                  type: 'line',
                  stations: subwayObj[plan.start.subway].slice(plan.end.index + 1, plan.start.index).reverse()
                })
              } else {
                plan.path.push({
                  type: 'line',
                  stations: subwayObj[plan.start.subway].slice(plan.start.index + 1, plan.end.index)
                })
              }
              that.temp24(plan, subwayObj, true)
            } else {
              //不在同一条线
              //找出起始线路里面的转换站
              let transList = []
              for (let i = 0; i < subwayObj[plan.start.subway].length; i++) {
                let station = subwayObj[plan.start.subway][i];
                if (station.id === plan.start.id || station.id === plan.end.id) {
                  continue
                }
                if (station.goto) {
                  transList.push(station)
                }
              }
              if (transList.length === 0) {
                alert('无法换乘')
                return false;
              }
              for (let i = 0; i < transList.length; i++) {
                transList[i].subway = plan.start.subway
                if (transList[i].goto.indexOf('|') > -1) {
                  let gotoList = transList[i].goto.split('|')
                  for (let k = 0; k < gotoList.length; k++) {
                    plan.path = []
                    let transfer = subwayObj[gotoList[k]].find(x => x.id === transList[i].id)
                    transfer.subway = gotoList[k]
                    if (plan.start.index > transList[i].index) {
                      plan.path.push({
                        type: 'line',
                        stations: subwayObj[plan.start.subway].slice(transList[i].index + 1, plan.start.index)
                          .reverse()
                      })
                    } else {
                      plan.path.push({
                        type: 'line',
                        stations: subwayObj[plan.start.subway].slice(plan.start.index + 1, transList[i].index)
                      })
                    }
                    plan.path.push({
                      type: 'transfer',
                      stations: [transList[i], transfer]
                    })
                    plans.push(plan)
                  }
                } else {
                  plan.path = []
                  let transfer = subwayObj[transList[i].goto].find(x => x.id === transList[i].id)
                  transfer.subway = transList[i].goto
                  if (plan.start.index > transList[i].index) {
                    plan.path.push({
                      type: 'line',
                      stations: subwayObj[plan.start.subway].slice(transList[i].index + 1, plan.start.index)
                        .reverse()
                    })
                  } else {
                    plan.path.push({
                      type: 'line',
                      stations: subwayObj[plan.start.subway].slice(plan.start.index + 1, transList[i].index)
                    })
                  }
                  plan.path.push({
                    type: 'transfer',
                    stations: [transList[i], transfer]
                  })
                  plans.push(JSON.parse(JSON.stringify(plan)));
                }
              }
            }
          }
        }
        that.temp23(plans, subwayObj, 1)
      },
      temp23(plans, subwayObj, flag) {
        if (plans.length === 0) {
          return false
        }
        flag++
        // console.log('temp23plans', plans)
        let newPlans = []
        let finishPlans = []
        for (let m = 0; m < plans.length; m++) {
          let plan = JSON.parse(JSON.stringify(plans[m]))
          let oldStation = plan.path[plan.path.length - 1].stations[1]
          let transList = []
          for (let i = 0; i < subwayObj[oldStation.subway].length; i++) {
            let station = subwayObj[oldStation.subway][i]
            if (station.id === oldStation.id) {
              continue
            }
            if (station.goto) {
              //是转换站
              if (station.goto.indexOf(plan.end.subway) > -1) {
                //可以直接转到终点的线路
                let transfer = subwayObj[plan.end.subway].find(x => x.id === station.id)
                transfer.subway = plan.end.subway
                if (oldStation.index > station.index) {
                  plan.path.push({
                    type: 'line',
                    stations: subwayObj[oldStation.subway].slice(station.index + 1, oldStation.index).reverse()
                  })
                } else {
                  plan.path.push({
                    type: 'line',
                    stations: subwayObj[oldStation.subway].slice(oldStation.index + 1, station.index)
                  })
                }
                plan.path.push({
                  type: 'transfer',
                  stations: [station, transfer]
                })
                finishPlans.push(plan)
              } else {
                transList.push(station)
              }
            }
          }
          if (transList.length === 0) {
            continue
          }
          for (let i = 0; i < transList.length; i++) {
            transList[i].subway = oldStation.subway
            if (transList[i].goto.indexOf('|') > -1) {
              let gotoList = transList[i].goto.split('|')
              for (let k = 0; k < gotoList.length; k++) {
                let plan = JSON.parse(JSON.stringify(plans[m]))
                let transfer = subwayObj[gotoList[k]].find(x => x.id === transList[i].id)
                transfer.subway = gotoList[k]
                if (oldStation.index > transList[i].index) {
                  plan.path.push({
                    type: 'line',
                    stations: subwayObj[oldStation.subway].slice(transList[i].index + 1, oldStation.index).reverse()
                  })
                } else {
                  plan.path.push({
                    type: 'line',
                    stations: subwayObj[oldStation.subway].slice(oldStation.index + 1, transList[i].index)
                  })
                }
                plan.path.push({
                  type: 'transfer',
                  stations: [transList[i], transfer]
                })
                newPlans.push(plan)
              }
            } else {
              let plan = JSON.parse(JSON.stringify(plans[m]))
              let transfer = subwayObj[transList[i].goto].find(x => x.id === transList[i].id)
              transfer.subway = transList[i].goto
              if (oldStation.index > transList[i].index) {
                plan.path.push({
                  type: 'line',
                  stations: subwayObj[oldStation.subway].slice(transList[i].index + 1, oldStation.index).reverse()
                })
              } else {
                plan.path.push({
                  type: 'line',
                  stations: subwayObj[oldStation.subway].slice(oldStation.index + 1, transList[i].index)
                })
              }
              plan.path.push({
                type: 'transfer',
                stations: [transList[i], transfer]
              })
              newPlans.push(plan)
            }
          }
        }
        console.log('flag', flag);
        if (finishPlans.length == newPlans.length || flag > 3) {
          this.temp24_pre(finishPlans, subwayObj)
        } else {
          this.temp23(newPlans, subwayObj, flag)
        }

      },
      temp24_pre(plans, subwayObj) {
        console.log('temp24_pre', plans)
        let results = []
        for (let i = 0; i < plans.length; i++) {
          let result = this.temp24(plans[i], subwayObj)
          results.push(result)
        }
        results.sort((a, b) => {
          return a.time - b.time
        })
        console.log('111', results[0].words)
      },
      temp24(plan, subwayObj, finish) {
        let start = plan.start
        let end = plan.end
        let path = plan.path
        if (path[path.length - 1].type === 'transfer') {
          let transfer = path[path.length - 1].stations[1]
          if (end.index > transfer.index) {
            path.push({
              type: 'line',
              stations: subwayObj[transfer.subway].slice(transfer.index + 1, end.index)
            })
          } else {
            path.push({
              type: 'line',
              stations: subwayObj[transfer.subway].slice(end.index + 1, transfer.index).reverse()
            })
          }
        }

        let time = 5; //初始有个等地铁的时间，2分钟一站，换乘站5分钟
        let words = []
        words.push('从' + start.subway + start.name + '出发')
        for (let i = 0; i < path.length; i++) {
          if (path[i].type === 'line') {
            if (path[i].stations.length > 0) {
              words.push('经过')
              for (let j = 0; j < path[i].stations.length; j++) {
                time += 2.5
                words.push(path[i].stations[j].name)
              }
            }
          } else {
            time += 7
            let transfer = path[i].stations[1]
            words.push('到' + transfer.name + '换乘' + transfer.subway)
          }
        }
        time += 2.5
        words.push('到达目标站' + end.name + ' 预计用时' + Math.ceil(time) + '分钟')
        if (finish) {
          console.log('222', words.join(' '))
        }
        return {
          time: time,
          words: words.join(' ')
        }
      },

      // 统一更改楼盘的某个属性
      temp25() {
        let that = this
        that.$open();
        // let list = JSON.parse(JSON.stringify(this.realList)) //所有楼盘
        let list = this.realList.filter(x => {
          return x.id === '29jkifrd9kl'
        })
        this.temp26(list)
      },
      temp26(list) {
        let that = this
        if (list.length === 0) {
          that.$close()
          return;
        }
        let theOne = list.splice(0, 1)[0];

        if (!theOne.building) {
          that.temp26(list)
          return;
        }
        let building = theOne.building;
        let newBuilding = that.changeBuilding(building)
        if (!newBuilding || newBuilding === building) {
          // console.log('没变')
          that.temp26(list)
          return;
        }
        let obj = {
          id: theOne.id,
          building: newBuilding
        };

        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.temp26(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.temp26(list)
        })
      },
      changeSunshine1(sunshine, name) {
        let sun = JSON.parse(sunshine);
        for (let i = 0, len = sun.length; i < len; i++) {
          if (sun[i].src.includes('http')) {
            continue;
          }
          let part = JSON.parse(sun[i].src).part;

          // 计算2-4，4-6，6-8小时分别是多少层
          let length = part[0][0].length;
          let range = {
            '2-4': [],
            '4-6': [],
            '6-8': []
          };
          for (let i = 0; i < length; i++) {
            let oneFloorTime = 0;
            let oneFloorNum = 0;
            for (let unit in part) {
              for (let num in part[unit]) {
                if (part[unit][num][i]) {
                  let sun = parseFloat(part[unit][num][i]['冬至']) || parseFloat(part[unit][num][i]['旧冬至']);
                  if (sun) {
                    oneFloorTime += sun;
                    oneFloorNum += 1;
                  }
                }
              }
            }
            if (oneFloorNum > 0) {
              let time = oneFloorTime / oneFloorNum;
              if (time > 2 && time <= 4) {
                range['2-4'].push(i + 1);
              } else if (time > 4 && time <= 6) {
                range['4-6'].push(i + 1);
              } else if (time > 6 && time <= 8) {
                range['6-8'].push(i + 1);
              }
            }
          }
          for (let key in range) {
            if (range[key].length === 0) {
              range[key] = '';
            } else if (range[key].length === 1) {
              range[key] = String(range[key][0]);
            } else {
              range[key] = range[key][0] + '-' + range[key][range[key].length - 1];
            }
          }
          sun[i].range = range;

          let winterList = [];
          for (let unit in part) {
            for (let num in part[unit]) {
              for (let floor in part[unit][num]) {
                if (!part[unit][num][floor] || typeof part[unit][num][floor] !== "object") {
                  continue;
                }
                if (part[unit][num][floor]['冬至']) {
                  let winter = parseFloat(part[unit][num][floor]['冬至']);
                  winterList.push(winter);
                } else if (part[unit][num][floor]['旧冬至']) {
                  let winter = parseFloat(part[unit][num][floor]['旧冬至']);
                  winterList.push(winter);
                }
              }
            }
          }
          if (winterList.length === 0) {
            console.log(name, sun[i].name);
            continue;
          }
          winterList.sort();
          let result = {};
          result.min = winterList[0];
          result.average = (winterList.reduce((a, b) => a + b) / winterList.length).toFixed(1).replace('.0', '');
          sun[i].result = result;
        }
        return JSON.stringify(sun);
      },
      changeSunshine2(sunshine, name) {
        let sun = JSON.parse(sunshine);
        for (let i = 0, len = sun.length; i < len; i++) {
          if (sun[i].src.includes('http')) {
            continue;
          }
          let src = JSON.parse(sun[i].src);
          let part = src.part;

          for (let unit in part) {
            for (let num in part[unit]) {
              for (let floor in part[unit][num]) {
                if (part[unit][num][floor]) {
                  if (part[unit][num][floor].hasOwnProperty('旧冬至')) {
                    if (part[unit][num][floor].hasOwnProperty('冬至')) {
                      delete part[unit][num][floor]['旧冬至'];
                    } else {
                      part[unit][num][floor]['冬至'] = part[unit][num][floor]['旧冬至'];
                      delete part[unit][num][floor]['旧冬至'];
                    }
                  }
                }
              }
            }
          }
          sun[i].src = JSON.stringify(src);
        }
        return JSON.stringify(sun);
      },
      changeEveryroom1(every_room) {
        let everyRoom = JSON.parse(every_room);
        for (let i = 0, len = everyRoom.length; i < len; i++) {
          let part = everyRoom[i].data;
          let allSquare = {};
          for (let unit in part) {
            for (let num in part[unit]) {
              for (let floor in part[unit][num]) {
                if (!part[unit][num][floor]) {
                  continue
                }
                let square = Math.floor(part[unit][num][floor]['建筑面积']);
                let wholePrice = part[unit][num][floor]['总价'];
                let piecePrice = part[unit][num][floor]['申请备案单价'];

                // 为了计算不同面积段的总价范围和平均单价
                let priceObj = {
                  wholePrice: wholePrice,
                  piecePrice: piecePrice
                }
                if (allSquare[square]) {
                  allSquare[square].push(priceObj)
                } else {
                  allSquare[square] = [priceObj]
                }

              }
            }
          }
          let average_price = []
          for (let key in allSquare) {
            let oneArr = allSquare[key];
            let length = oneArr.length;
            oneArr.sort((a, b) => {
              return a.wholePrice - b.wholePrice;
            })
            let total = 0;
            oneArr.forEach(x => total += x.piecePrice);
            let pushObj = {
              square: key,
              minPrice: parseInt(oneArr[0].wholePrice),
              maxPrice: parseInt(oneArr[length - 1].wholePrice),
              piecePrice: Math.round(total / length)
            }
            average_price.push(pushObj);
          }
          average_price.sort((a, b) => {
            return a.square - b.square;
          })
          everyRoom[i].average_price = average_price;
        }
        return JSON.stringify(everyRoom);
      },
      changeEveryroom(every_room) { // 计算选房顺序
        let everyRoom = JSON.parse(every_room);
        for (let i = 0, len = everyRoom.length; i < len; i++) {
          if (this.hasSunshine(everyRoom[i].data)) {
            this.chooseRoom(everyRoom[i]);
          }
        }
        return JSON.stringify(everyRoom);
      },
      changeEveryroom3(every_room) { // 取一小部分数据用来显示小表格
        let everyRoom = JSON.parse(every_room);
        for (let i = 0, len = everyRoom.length; i < len; i++) {
          let part = JSON.parse(JSON.stringify(everyRoom[i].data));
          for (let unit in part) {
            for (let num in part[unit]) {
              for (let floor in part[unit][num]) {
                if (!part[unit][num][floor]) {
                  continue
                }

              }
            }
          }
        }
        return JSON.stringify(everyRoom);
      },
      changeBuilding(building) { // 算月供和取两层
        let list = JSON.parse(building);
        for (let i = 0, len = list.length; i < len; i++) {
          if (!list[i].data) {
            continue;
          }
          let floors = [];
          let part = list[i].data
          for (let unit in part) {
            for (let num in part[unit]) {
              for (let floor in part[unit][num]) {
                let oneRoom = part[unit][num][floor];
                if (!oneRoom) {
                  continue
                }
                if (oneRoom['总价']) {
                  if (!oneRoom['装修价']) {
                    delete oneRoom['装修价']
                  }
                  oneRoom['成数'] = '3成' + parseInt(0.3 * oneRoom['总价']) + '万';
                  oneRoom['月供'] = this.everyMonth(oneRoom['总价'] * 10000 * 0.7);
                }
                if (unit == 0) {
                  if (list[i].hasSun && list[i].hasPrice) {
                    if (oneRoom['冬至'] && oneRoom['总价']) {
                      floors.push(parseInt(floor));
                    }
                  } else if (list[i].hasSun && oneRoom['冬至']) {
                    floors.push(parseInt(floor));
                  } else if (list[i].hasPrice && oneRoom['总价']) {
                    floors.push(parseInt(floor));
                  }
                }
              }
            }
          }
          floors.sort((a, b) => {
            return a - b;
          });
          // console.log('floors',floors);
          if (floors.length > 1) {
            list[i].small = [floors[0], floors[floors.length - 1]];
          } else if (floors.length === 1) {
            list[i].small = floors;
          } else {
            console.log('什么情况')
          }
        }
        return JSON.stringify(list);
      },
      recordCode() {
        let obj = {};
        if (theOne.sunshine) {
          let sunshine = theOne.sunshine;
          let newSunshine = that.changeSunshine(sunshine)
          if (newSunshine && newSunshine !== sunshine) {
            obj.sunshine = newSunshine;
          }
        }
        if (theOne.every_room) {
          let every_room = theOne.every_room;
          let newEveryRoom = that.changeEveryroom(every_room)
          if (newEveryRoom && newEveryRoom !== every_room) {
            obj.every_room = newEveryRoom;
          }
        }
        if (JSON.stringify(obj) === "{}") {
          that.temp26(list);
          return;
        }
        obj.id = theOne.id;

        if (!theOne.building) {
          that.temp26(list)
          return;
        }
        let building = theOne.building;
        let newBuilding = that.changeBuilding(building)
        if (!newBuilding || newBuilding === building) {
          that.temp26(list)
          return;
        }

        if (!theOne.sunshine) {
          that.temp26(list)
          return;
        }
        let sunshine = JSON.parse(theOne.sunshine);
        let images = sunshine.filter(x => {
          return x.src.includes('.gif');
        })
        // let obj = {
        //   id: theOne.id
        // };
        if (images.length > 0) {
          obj.sunLight = JSON.stringify(images);
        } else {
          obj.sunLight = ''
        }
      },
      modifyOneReal() {
        let that = this;
        let obj = {
          id: '1ft2cmle9is',
          building: ''
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传', res)
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },
      chooseRoom(priceObj) {
        let that = this
        let list = priceObj.data
        let total_floor = list[0][0].length; // 总层高
        let westest_unit = list.length; // 西边套的单元号
        let westest_num = list[westest_unit - 1].length; // 西边套的房号
        let limit_floor = 0;
        if (total_floor > 18) {
          limit_floor = 5;
        } else if (total_floor > 9) {
          limit_floor = 4;
        } else if (total_floor > 4) {
          limit_floor = 3;
        }
        let total_num = 0;
        let all = [];
        for (let unit = 0; unit < list.length; unit++) {
          total_num += list[unit].length;
          for (let num = 0; num < list[unit].length; num++) {
            for (let floor = 0; floor < list[unit][num].length; floor++) {
              if (list[unit][num][floor]) {
                let oneHouse = JSON.parse(JSON.stringify(list[unit][num][floor]));
                oneHouse.unit = unit + 1;
                oneHouse.num = num + 1;
                oneHouse.floor = floor + 1;
                oneHouse.whole_num = total_num + oneHouse.num;
                if (list[unit][num].length === (floor + 1)) {
                  oneHouse.top = true;
                }
                all.push(oneHouse);
              }
            }
          }
        }
        priceObj['allLength'] = all.length
        for (let i = 0; i < all.length; i++) {
          let oneHouse = all[i];
          let price = oneHouse['申请备案单价']; // 价格，越低越好
          let sun = oneHouse['日照']; // 日照，越高越好
          let floor = oneHouse.floor; // 楼层，最低的若干层减分
          let up = 0; // 分子，放越大越好的
          let sun_dividing_c = Number(that.chooseHouse['sun_dividing'])
          let sun_small_c = Number(that.chooseHouse['sun_small'])
          let sun_big_c = Number(that.chooseHouse['sun_big'])
          let low_floor_c = Number(that.chooseHouse['low_floor'])
          let square_c = Number(that.chooseHouse['square'])
          let good_c = Number(that.chooseHouse['good'])
          let bad_c = Number(that.chooseHouse['bad'])
          let top_c = Number(that.chooseHouse['top'])
          let east_c = Number(that.chooseHouse['east'])
          let west_c = Number(that.chooseHouse['west'])

          if (sun >= sun_dividing_c) {
            up = (sun - sun_dividing_c) * sun_small_c + sun_dividing_c * sun_big_c
          } else {
            up = sun * sun_big_c
          }
          let down = price; // 分母，放越小越好的

          if (floor < limit_floor) { // 低楼层减分
            down = down + (limit_floor - floor) * low_floor_c;
          }
          if (priceObj.east) { // 东
            up = up + (total_num - oneHouse.whole_num + 1) * good_c * priceObj.east.good.length;
            up = up + (oneHouse.whole_num) * good_c * priceObj.east.bad.length;
          }
          if (priceObj.west) { // 西
            down = down + (oneHouse.whole_num) * bad_c * priceObj.west.good.length;
            down = down + (total_num - oneHouse.whole_num + 1) * bad_c * priceObj.west.bad.length;
          }
          if (oneHouse.top) { // 顶楼 要减分
            down += top_c;
          }
          if (oneHouse.unit === 1 && oneHouse.num === 1) { // 东边套，要加分
            up += east_c;
          }
          if (oneHouse.unit === westest_unit && oneHouse.num === westest_num) { // 西边套，要加分
            up += west_c;
          }
          oneHouse.rate = (up / down) * 100000;
        }
        all.sort((a, b) => {
          if (a.rate === b.rate) {
            if (a.floor === b.floor) {
              if (a.unit === b.unit) {
                return a.num - b.num;
              }
              return a.unit - b.unit;
            }
            return b.floor - a.floor;
          }
          return b.rate - a.rate;
        })
        for (let unit = 0; unit < list.length; unit++) {
          for (let num = 0; num < list[unit].length; num++) {
            for (let floor = 0; floor < list[unit][num].length; floor++) {
              if (list[unit][num][floor]) {
                let result = all.findIndex(x => {
                  if (x.unit === unit + 1 && x.num === num + 1 && x.floor === floor + 1) {
                    return true;
                  }
                })
                list[unit][num][floor].order = result + 1;
                // delete list[unit][num][floor].order;
              }
            }
          }
        }
      },
      hasSunshine(data) {
        for (let unit in data) {
          for (let num in data[unit]) {
            for (let floor in data[unit][num]) {
              if (data[unit][num][floor]) {
                if (data[unit][num][floor]['日照']) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      },
      everyMonth(price) { // 计算月供
        let year = 30;
        let base_lilv = 4.9;
        let lilv = base_lilv * 1.1;
        let yuelilv = lilv / 1200
        let qishu = year * 12
        let yuegong = parseInt(price * yuelilv * (1 + yuelilv) ** qishu / ((1 + yuelilv) ** qishu - 1))
        return yuegong
      },

      temp32() { //计算贷款
        let money = parseInt(this.money) * 10000
        let year = parseInt(this.year)
        let yuelilv = 0.049 / 12
        let qishu = year * 12
        if (this.pay_way === '等额本金') {
          let benjin = money / qishu
          let list = new Array(qishu)
          for (let i = 0; i < list.length; i++) {
            let obj = {}
            let lixi = (money - i * benjin) * yuelilv
            obj.index = i + 1
            obj.benjin = benjin.toFixed(2)
            obj.lixi = lixi.toFixed(2)
            obj.yuegong = (benjin + lixi).toFixed(2)
            list[i] = obj
          }
          console.log(list)
        } else {
          let list = new Array(qishu)
          let yuegong = money * yuelilv * (1 + yuelilv) ** qishu / ((1 + yuelilv) ** qishu - 1)
          for (let i = 0; i < list.length; i++) {
            let obj = {}
            let benjin = money * yuelilv * (1 + yuelilv) ** i / ((1 + yuelilv) ** qishu - 1)
            let lixi = (money - i * benjin) * yuelilv
            obj.index = i + 1
            obj.benjin = benjin.toFixed(2)
            obj.yuegong = yuegong.toFixed(2)
            obj.lixi = (obj.yuegong - obj.benjin).toFixed(2)
            list[i] = obj
          }
          console.log(list)
        }
      },

      // 置业顾问没有楼盘名
      salesNoReal() {
        let that = this;
        let result = [];
        that.$axios.get(that.$url_prefix + 'getSalerList').then(function (res) {
          let list = res.data.data;
          console.log('list', list);
          list.forEach(x => {
            if (!x.real_estate_name) {
              result.push(x);
            }
          })
          let length = result.length;
          if (length === 0) {
            console.log('没有无楼盘名的顾问');
          } else {
            console.log(`有${length}个没有楼盘名`, result);
          }
          console.log('去核对顾问的楼盘名')
          that.setRealNameForSale(list);
        })

      },
      // 给置业顾问绑定楼盘名
      setRealNameForSale(list) {
        let that = this;
        if (list.length === 0) {
          return;
        }
        let theOne = list.splice(0, 1)[0];
        if (theOne.real_name) {
          if (theOne.real_estate_name === theOne.real_name) {
            that.setRealNameForSale(list);
            return;
          }
        } else {
          that.setRealNameForSale(list);
          return;
        }
        console.log('要更新楼盘名', theOne);
        let obj = {
          id: theOne.id,
          real_estate_name: theOne.real_name //要改的属性
        }
        let param = {
          'db': 'WpUserModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.setRealNameForSale(list);
        }).catch(function (res) {
          console.log('上传失败', res);
          that.setRealNameForSale(list);
        })
      },

      // 统计点击
      templfasheofh() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'behaviourAnalyse', {
          params: {
            type: '楼盘搜索',
            from: '首页'
          }
        }).then(function (res) {
          // console.log('res', res)
          let list = res.data.data.filter(x => x.target === '不限购');
          console.log('list', list)
          // let openidlist = [];
          // let result = 0;
          // for (let i = 0, len = list.length; i < len; i++) {
          //   if (openidlist.indexOf(list[i].open_id) === -1) {
          //     openidlist.push(list[i].open_id);
          //     result++
          //   }
          // }
          // console.log('result', result);
        })
      },
      tem64heofh() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'behaviourAnalyse', {
          params: {
            type: '点击组件'
          }
        }).then(function (res) {
          console.log('res', res)
          let list = res.data.data;
          let result = {};
          for (let i = 0, len = list.length; i < len; i++) {
            if (result[list[i].target]) {
              result[list[i].target]++
            } else {
              result[list[i].target] = 1
            }
          }
          console.log('result', result);
        })
      },

      tepfawe() { // 修改数据选房系数
        let that = this;
        let obj = {
          id: '1884jgyw2tu',
          data: JSON.stringify({
            sun_dividing: 6, // 日照分界
            sun_small: 100, // 日照比重, 高于分界的
            sun_big: 1000, // 日照比重, 低于分界的
            low_floor: 8000, // 底层减分
            low_diff: 400, // 低楼层减分
            low_divid: 5, // 低楼层分界, 小于5层的算低楼层
            square: 200, // 面积系数, 投资小的好, 自住大的好
            good: 5, // 有利因素
            bad: 40, // 不利因素
            top: 8000, // 顶楼减分
            east: 500, // 东边套加分
            west: 500, // 西边套加分

            noise: 0, // 噪声, x层为分界, 靠马路的x层最吵, 不靠马路的x层最安静
            noise_divid: 10, // 噪声分界

            normal: 40000, // 标准价格, 没有价格的时候用这个
          })
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新数据选房系数返回', res)
        }).catch(function (res) {
          console.log('更新数据选房系数失败', res)
        })
      },
      tepddddfawe() { // 修改数据选房系数
        let that = this;
        let obj = {
          id: 'bfqzgkf1ed',
          data: JSON.stringify({
            sun: 1, // 日照系数
            low_floor: 50, // 底层减分
            low_diff: 10, // 低楼层减分
            low_divid: 5, // 低楼层分界, 小于5层的算低楼层
            good: 0.4, // 有利因素
            bad: 2, // 不利因素
            top: 50, // 顶楼减分
            east: 10, // 东边套加分
            west: 10, // 西边套加分

            noise: 0, // 噪声, x层为分界, 靠马路的x层最吵, 不靠马路的x层最安静
            noise_divid: 10, // 噪声分界

            normal: 40000, // 标准价格, 没有价格的时候用这个

            square: 200, // 面积系数, 投资小的好, 自住大的好
          })
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新数据选房系数返回', res)
        }).catch(function (res) {
          console.log('更新数据选房系数失败', res)
        })
      },

      templsef() { // 修改楼市提问标签
        let that = this;
        let obj = {
          id: '1438y4smh43',
          data: JSON.stringify([
            '全部',
            '贷款',
            '落户',
            '限购',
            '社保',
            '公积金',
            '楼盘对比',
            '刚需',
            '改善',
            '投资',
            '其它'
          ])
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新楼市提问标签返回', res)
        }).catch(function (res) {
          console.log('更新楼市提问标签失败', res)
        })
      },

      withdrawContributeScore() { // 撤回置业顾问的贡献分
        let that = this;
        that.$axios.get(that.$url_prefix + 'withdrawContributeScore', {
          params: {
            user_id: '1l9mvd1bl5',
            score: 20
          }
        }).then(function (res) {
          console.log('更新楼市提问标签返回', res)
        }).catch(function (res) {
          console.log('更新楼市提问标签失败', res)
        })
      },

      lsefhaefhcnvh() { // 管理区域中心点, 小程序地图页面显示区文字
        let that = this;
        let obj = {
          id: '1inv5e2wd7w',
          data: JSON.stringify({
            '西湖区': {
              center: [120.094868, 30.28064]
            },
            '上城区': {
              center: [120.181686, 30.234044]
            },
            '下城区': {
              center: [120.176155, 30.290945]
            },
            '拱墅区': {
              center: [120.13984, 30.317992]
            },
            '江干区': {
              center: [120.220577, 30.274376]
            },
            '滨江区': {
              center: [120.210019, 30.201829]
            },
            '萧山区': {
              center: [120.2693, 30.182104]
            },
            '钱塘新区': {
              center: [120.35666, 30.317928]
            },
            '余杭区': {
              center: [120.029157, 30.382968]
            },
            '富阳区': {
              center: [119.945011, 30.051712]
            },
            '临安区': {
              center: [119.73236, 30.230955]
            }
          })
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新区域中心点返回', res)
        }).catch(function (res) {
          console.log('更新区域中心点失败', res)
        })
      },

      // 遍历改变户型数据
      modifyCanvasData() {
        let that = this
        that.$axios.get(that.$url_prefix + 'queryApartmentList').then(function (res) {
          console.log('查询返回', res)
          that.$open();
          that.mcdRecursive(res.data.data)
        }).catch(function (res) {
          console.log('查询失败', res)
        })
      },
      mcdRecursive(apartmentDataList) {
        let that = this
        if (apartmentDataList.length === 0) {
          that.$close()
          return
        }
        let apartment = apartmentDataList.splice(0, 1)[0]
        if (!apartment.canvas_data && !apartment.multi_data) {
          that.mcdRecursive(apartmentDataList)
          return
        }
        let obj = {
          id: apartment.real_estate_id
        };
        if (apartment.canvas_data) {
          let canvasData = JSON.parse(apartment.canvas_data)
          for (let i = 0, len = canvasData.chuang.length; i < len; i++) {
            let wall = canvasData.walls.find(x => x.id === canvasData.chuang[i].wall_id);
            let length;
            if (wall.direction === '竖直') {
              length = Math.abs(wall.start[1] - wall.end[1]) * 20 * canvasData.zoom
            } else if (wall.direction === '水平') {
              length = Math.abs(wall.start[0] - wall.end[0]) * 20 * canvasData.zoom
            }
            if (length) {
              let width = parseInt(length * 0.75);
              canvasData.chuang[i].width = width;
            }
          }
          for (let i = 0, len = canvasData.doors.length; i < len; i++) {
            if (canvasData.doors[i].shape !== 'move_door') {
              continue
            }
            let wall = canvasData.walls.find(x => x.id === canvasData.doors[i].wall_id);
            let length;
            if (wall.direction === '竖直') {
              length = Math.abs(wall.start[1] - wall.end[1]) * 20 * canvasData.zoom
            } else if (wall.direction === '水平') {
              length = Math.abs(wall.start[0] - wall.end[0]) * 20 * canvasData.zoom
            }
            if (length) {
              let width = parseInt(length * 0.75);
              canvasData.doors[i].width = width;
            }
          }
          obj.canvas_data = JSON.stringify(canvasData);
        } else if (apartment.multi_data) {
          let multiData = JSON.parse(apartment.multi_data)
          for (let k = 0, len = multiData.length; k < len; k++) {
            let canvasData = multiData[k];
            for (let i = 0, leng = canvasData.chuang.length; i < leng; i++) {
              let wall = canvasData.walls.find(x => x.id === canvasData.chuang[i].wall_id);
              let length;
              if (wall.direction === '竖直') {
                length = Math.abs(wall.start[1] - wall.end[1]) * 20 * canvasData.zoom
              } else if (wall.direction === '水平') {
                length = Math.abs(wall.start[0] - wall.end[0]) * 20 * canvasData.zoom
              }
              if (length) {
                let width = parseInt(length * 0.75);
                canvasData.chuang[i].width = width;
              }
            }
            for (let i = 0, leng = canvasData.doors.length; i < leng; i++) {
              if (canvasData.doors[i].shape !== 'move_door') {
                continue
              }
              let wall = canvasData.walls.find(x => x.id === canvasData.doors[i].wall_id);
              let length;
              if (wall.direction === '竖直') {
                length = Math.abs(wall.start[1] - wall.end[1]) * 20 * canvasData.zoom
              } else if (wall.direction === '水平') {
                length = Math.abs(wall.start[0] - wall.end[0]) * 20 * canvasData.zoom
              }
              if (length) {
                let width = parseInt(length * 0.75);
                canvasData.doors[i].width = width;
              }
            }
          }
          obj.multi_data = JSON.stringify(multiData);
        }

        let param = {
          'db': 'WpApartmentModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        };
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          // console.log('上传数据返回', res)
          that.mcdRecursive(apartmentDataList)
        }).catch(function (res) {
          console.log('上传数据失败', res)
          that.mcdRecursive(apartmentDataList)
        })

      },
      shehaglsfenv() {
        let list = this.realList;
        for (let i = 0, len = list.length; i < len; i++) {
          if (list[i].apartment) {
            let apartment = JSON.parse(list[i].apartment);
            let imgList = apartment.imgList;
            for (let k = 0, leng = imgList.length; k < leng; k++) {
              if (imgList[k].defang) {
                if (parseInt(imgList[k].defang) > 90) {
                  console.log(list[i].real_estate_name, imgList[k].imgName2);
                }
              }
            }
          }
        }
      },
      shesegenv() {
        let that = this;
        let list = this.realList;
        let result = [];
        for (let i = 0, len = list.length; i < len; i++) {
          if (list[i].apartment) {
            let imgList = JSON.parse(list[i].apartment).imgList;
            for (let k = 0, len = imgList.length; k < len; k++) {
              if (imgList[k].house_type) {
                let obj = {
                  real_estate_id: list[i].id,
                  serial_number: imgList[k].imgName2,
                  house_type: imgList[k].house_type
                }
                result.push(obj);
              }
            }
          }
        }

        // that.$open();
        // this.jahefhhaef(result);
        console.log(result);
      },
      jahefhhaef(list) {
        let that = this;
        if (list.length === 0) {
          that.$close()
          return;
        }

        let theOne = list.splice(0, 1)[0];
        let param = {
          'db': 'WpApartmentModel',
          'model': 'apartment',
          'item': JSON.stringify(theOne)
        };
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.jahefhhaef(list)
        }).catch(function (res) {
          console.log('上传数据失败', res)
          that.jahefhhaef(list)
        })
      },

      afahefuchvnse1() { // 统计户型数据卫生间
        let list = this.apartmentDataList;
        let toilet_ke = [];
        let toilet_zhu = [];
        for (let i = 0, len = list.length; i < len; i++) {
          let one = list[i];
          if (one.room) {
            let rooms = JSON.parse(one.room);
            for (let k = 0, lenn = rooms.length; k < lenn; k++) {
              if (rooms[k].type === '客卫') {
                toilet_ke.push(rooms[k].square)
              } else if (rooms[k].type === '主卫') {
                toilet_zhu.push(rooms[k].square)
              }
            }
          }
        }
        toilet_ke.sort((a, b) => {
          return b - a;
        })
        toilet_zhu.sort((a, b) => {
          return b - a;
        })
        console.log('toilet_ke', toilet_ke);
        console.log('toilet_zhu', toilet_zhu);
      },
      afahefuchvnse2() { // 统计户型数据客餐厅
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryApartmentRoom').then(function (res) {
          let list = res.data.data;
          let kt = []; // 客厅
          let ct = []; // 餐厅
          let kct = []; // 客餐厅
          for (let i = 0, len = list.length; i < len; i++) {
            let one = list[i];
            if (one.room) {
              let rooms = JSON.parse(one.room);
              for (let k = 0, lenn = rooms.length; k < lenn; k++) {
                if (rooms[k].type === '客厅') {
                  kt.push(rooms[k].square)
                } else if (rooms[k].type === '餐厅') {
                  ct.push(rooms[k].square)
                } else if (rooms[k].type === '客餐厅') {
                  kct.push(rooms[k].square)
                }
              }
            }
          }
          kt.sort((a, b) => {
            return b - a;
          })
          ct.sort((a, b) => {
            return b - a;
          })
          kct.sort((a, b) => {
            return b - a;
          })
          let kt_l1 = Math.round(kt[parseInt(kt.length * 0.15)]);
          let kt_l2 = Math.round(kt[parseInt(kt.length * 0.35)]);
          let kt_l3 = Math.round(kt[parseInt(kt.length * 0.85)]);

          let ct_l1 = Math.round(ct[parseInt(ct.length * 0.15)]);
          let ct_l2 = Math.round(ct[parseInt(ct.length * 0.35)]);
          let ct_l3 = Math.round(ct[parseInt(ct.length * 0.85)]);

          let kct_l1 = Math.round(kct[parseInt(kct.length * 0.15)]);
          let kct_l2 = Math.round(kct[parseInt(kct.length * 0.35)]);
          let kct_l3 = Math.round(kct[parseInt(kct.length * 0.85)]);

          console.log('客厅', kt);
          console.log('餐厅', ct);
          console.log('客餐厅', kct);

          console.log('客厅', [kt_l1, kt_l2, kt_l3].join(', '));
          console.log('餐厅', [ct_l1, ct_l2, ct_l3].join(', '));
          console.log('客餐厅', [kct_l1, kct_l2, kct_l3].join(', '));
        })
      },

      getNewestData() { // 找出最新评测的日照，选房，户型
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id real_estate_name building apartment'
          }
        }).then((res) => {
          let realList = res.data.data;
          let result = {};
          let apartmentArr = [];
          let sunshineArr = [];
          let everyRoomArr = [];
          let priceArr = [];
          for (let i = 0, len = realList.length; i < len; i++) {
            let oneReal = realList[i];
            if (oneReal.building) {
              let building = JSON.parse(oneReal.building);
              for (let k = 0, lenn = building.length; k < lenn; k++) {
                if (building[k].small && building[k].small[0] !== building[k].small[1]) { // 排除只有1层的
                  building[k].real_estate_id = oneReal.id;
                  building[k].real_estate_name = oneReal.real_estate_name;
                  if (building[k].stime && building[k].hasSun && building[k].sorth) {
                    sunshineArr.push(building[k]);
                  }
                  if (building[k].ptime && building[k].hasPrice) {
                    priceArr.push(building[k]);
                  }
                  if (building[k].ptime && building[k].hasPrice && building[k].stime && building[k].hasSun) {
                    everyRoomArr.push(building[k]);
                  }
                }
              }
            }
            if (oneReal.apartment) {
              let apartment = JSON.parse(oneReal.apartment).imgList;
              for (let k = 0, lenn = apartment.length; k < lenn; k++) {
                if (apartment[k].time && apartment[k].label) {
                  apartment[k].real_estate_id = oneReal.id;
                  apartment[k].real_estate_name = oneReal.real_estate_name;
                  apartmentArr.push(apartment[k]);
                }
              }
            }
          }
          apartmentArr.sort((a, b) => {
            return b.time - a.time;
          })
          sunshineArr.sort((a, b) => {
            return b.stime - a.stime;
          })
          everyRoomArr.sort((a, b) => {
            let timea = a.ptime;
            let timeb = b.ptime;
            if (a.stime > timea) {
              timea = a.stime;
            }
            if (b.stime > timeb) {
              timeb = b.stime;
            }
            return timeb - timea;
          })
          priceArr.sort((a, b) => {
            return b.ptime - a.ptime;
          })
          let apartmentList = [];
          let sunshineList = [];
          let everyRoomList = [];
          let priceList = [];
          apartmentArr.forEach((x) => {
            let findResult = apartmentList.find((y) => {
              return y.real_estate_id === x.real_estate_id;
            })
            if (!findResult) {
              apartmentList.push(x);
            }
          })
          sunshineArr.forEach((x) => {
            let findResult = sunshineList.find((y) => {
              return y.real_estate_id === x.real_estate_id;
            })
            if (!findResult) {
              sunshineList.push(x);
            }
          })
          everyRoomArr.forEach((x) => {
            let findResult = everyRoomList.find((y) => {
              return y.real_estate_id === x.real_estate_id;
            })
            if (!findResult) {
              everyRoomList.push(x);
            }
          })
          priceArr.forEach((x) => {
            let findResult = priceList.find((y) => {
              return y.real_estate_id === x.real_estate_id;
            })
            if (!findResult) {
              priceList.push(x);
            }
          })
          result.apartment = apartmentList.slice(0, 5);
          result.sunshine = sunshineList.slice(0, 5);
          result.everyRoom = everyRoomList.slice(0, 5);
          result.priceList = priceList.slice(0, 5);
          console.log('result', result);
          let obj = {
            id: 'e6zq8zn4ho',
            data: JSON.stringify(result)
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新最新评测内容返回', res)
          }).catch(function (res) {
            console.log('更新最新评测内容失败', res)
          })
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      hotSearch() { // 热门搜索楼盘名
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals', {
          params: {
            project: 'id real_estate_name real_status search_count'
          }
        }).then((res) => {
          let list = res.data.data;
          list.sort((a, b) => {
            let tempa = a.search_count || 0;
            let tempb = b.search_count || 0;
            return tempb - tempa;
          })
          let result = [];
          for (let i = 0; i < 10; i++) {
            result.push(list[i].real_estate_name);
          }
          console.log('result', result);
          // let obj = {
          //   id: '29u7cojkuah',
          //   data: JSON.stringify(result)
          // }
          // let param = {
          //   'db': 'WpBackupModel',
          //   'model': 'edit',
          //   'item': JSON.stringify(obj)
          // }
          // that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          //   console.log('更新热门搜索返回', res)
          // }).catch(function (res) {
          //   console.log('更新热门搜索失败', res)
          // })
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      // 几站到哪里
      fxhakchebga(nearObj) {
        let stations = JSON.parse(JSON.stringify(this.stationList));
        // let stations = this.stationList.filter(x => {
        //   return x.id === 'zk6t26gjpr';
        // });
        let subways = JSON.parse(JSON.stringify(this.subwayList));
        this.shcaefxcaefa(stations, subways, nearObj);
      },
      shcaefxcaefa(stations, subways, nearObj) {
        let that = this;
        if (stations.length === 0) {
          this.$close();
          return;
        }
        let station = stations.splice(0, 1)[0];
        let origin = station.subway_station;
        let arrive = {};
        let pass = [station];
        let next = this.getNextStation(station, subways, origin);
        arrive[1] = [];
        next.forEach((x) => {
          let findResult = pass.find((y) => {
            return y.id === x.id;
          });
          if (!findResult) {
            pass.push(x);
            arrive[1].push(x);
          }
        })
        for (let step = 2; step < 11; step++) {
          let theLast = arrive[step - 1];
          arrive[step] = [];
          for (let i = 0; i < theLast.length; i++) {
            next = this.getNextStation(theLast[i], subways, origin);
            next.forEach((x) => {
              let findResult = pass.find((y) => {
                return y.id === x.id;
              });
              if (!findResult) {
                if (!x.line) {
                  console.log('what no line?', x);
                }
                if (!this.noChange(x.line, theLast[i].line)) { // 换线路了
                  x.change = (theLast[i].change || 0) + 1;
                } else {
                  x.change = theLast[i].change || 0;
                }
                let change = x.change || 0;
                if (change <= 0) {
                  pass.push(x);
                  arrive[step].push(x);
                }
              }
            })
          }
        }
        let result = [];
        for (let key in arrive) {
          let tempArr = [];
          for (let i = 0, len = arrive[key].length; i < len; i++) {
            let tempS = JSON.parse(JSON.stringify(arrive[key][i])); // 某个到达站
            if (nearObj[tempS.id]) {
              let nearby = JSON.parse(JSON.stringify(nearObj[tempS.id])); // 到达站附近的配套
              // 处理重复到达同一地点的站, 留距离最近的
              loop_nearby:
                for (let k = 0; k < nearby.length; k++) {
                  for (let m = 0; m < result.length; m++) {
                    for (let n = 0; n < result[m].stations.length; n++) {
                      for (let p = 0; p < result[m].stations[n].nearby.length; p++) {
                        let theNear = result[m].stations[n].nearby[p];
                        if (theNear.id === nearby[k].id) {
                          if (theNear.distance < nearby[k].distance) {
                            nearby.splice(k, 1)
                            k--
                            continue loop_nearby
                          } else {
                            result[m].stations[n].nearby.splice(p, 1)
                            p--
                          }
                        }
                      }
                    }
                  }
                }
              // 看看地铁站本身的附近配套有没有重复的且距离更近的
              if (nearObj[station.id] && nearby.length > 0) {
                let originNearby = JSON.parse(JSON.stringify(nearObj[station.id]));
                // console.log('originNearby', originNearby);
                for (let k = 0; k < nearby.length; k++) {
                  let find = originNearby.find(x => x.id === nearby[k].id && x.distance < nearby[k.distance]);
                  if (find) {
                    nearby.splice(k, 1)
                    k--
                  }
                }
              }
              if (nearby.length > 0) {
                tempS.nearby = nearby
                delete tempS.id;
                delete tempS.goto;
                delete tempS.index;
                delete tempS.position;
                tempArr.push(tempS);
              }
            }
            // tempArr.push(tempS);
          }
          if (tempArr.length > 0) {
            result.push({
              step: key,
              stations: tempArr
            })
          }
        }
        if (result.length === 0) {
          this.shcaefxcaefa(stations, subways, nearObj);
          return;
        }

        // 去掉没有附近配套的到达站
        for (let i = 0; i < result.length; i++) {
          let splitS = [];
          result[i].stations.forEach(x => {
            if (x.nearby.length > 0) {
              if (x.line.includes('|')) {
                let tempa = x.line.split('|');
                tempa.forEach(y => {
                  let tempx = JSON.parse(JSON.stringify(x));
                  tempx.line = y;
                  splitS.push(tempx);
                })
              } else {
                splitS.push(x);
              }
            }
          })
          result[i].stations = splitS;
        }
        result = result.filter(x => {
          return x.stations.length > 0;
        })

        let rMap = {};
        let flat = [];
        for (let i = 0; i < result.length; i++) {
          for (let k = 0; k < result[i].stations.length; k++) {
            let line = result[i].stations[k].line;
            delete result[i].stations[k].line;
            delete result[i].stations[k].change;
            result[i].stations[k].nearby.forEach(x => {
              delete x.id;
              delete x.distance;
            })
            if (!rMap[line]) {
              rMap[line] = [];
            }
            let dir = result[i].stations[k].dir;
            delete result[i].stations[k].dir;
            delete result[i].stations[k].lnglat;
            delete result[i].stations[k].stage;
            delete result[i].stations[k].start;
            rMap[line].push({
              step: parseInt(result[i].step),
              dir: dir,
              stations: [result[i].stations[k]]
            });
          }
        }
        for (let key in rMap) {
          rMap[key].push({ // 本站
            step: 0,
            dir: 0,
            stations: [{
              name: station.location_name
            }]
          })
          rMap[key].sort((a, b) => {
            return b.dir * b.step - a.dir * a.step;
          })
          let frontIndex = 0;
          rMap[key].forEach((v, i) => {
            if (v.step == 0 && i > 1) {
              frontIndex = i - 1;
            }
            delete v.dir;
          })
          flat.push({
            line: key,
            index: frontIndex, // 本站前一站的index,用于前端展示滚到指定位置
            list: rMap[key]
          })
        }

        console.log('zz', station.location_name, flat);
        // that.shcaefxcaefa(stations, subways, nearObj);

        let obj = {
          id: station.id,
          reach: flat
        }
        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('update station back', res)
          that.shcaefxcaefa(stations, subways, nearObj);
        }).catch(function (res) {
          console.log('update station fail', res)
          that.shcaefxcaefa(stations, subways, nearObj);
        })
      },
      getNextStation(station, subways, origin) {
        let next = [];
        let line = '';
        if (station.subway_station) {
          line = station.subway_station;
        } else if (station.line) {
          if (station.goto) {
            line = station.line + '|' + station.goto;
          } else {
            line = station.line;
          }
        } else {
          console.log('noline', station);
        }
        let lineArr = Array.from(new Set(line.split('|')));
        for (let i = 0; i < subways.length; i++) {
          let subway = subways[i];
          if (!lineArr.includes(subway.name)) {
            continue;
          }
          let lineStations = JSON.parse(subway.station);
          let lineStation = lineStations.find((x) => {
            return x.id === station.id;
          })
          if (!lineStation) {
            if (!subway.name) {
              console.log('no name', subway);
            }
            // console.log('地铁线中没有找到该站', subway.name, station);
            continue;
          }
          let limit = lineStations.length - 1;
          // 往大的走
          if (lineStation.index < limit) {
            let pushObj = lineStations[lineStation.index + 1];
            pushObj.dir = 1;
            next.push(pushObj);
          }
          // 往小的走
          if (lineStation.index > 0) {
            let pushObj = lineStations[lineStation.index - 1];
            pushObj.dir = -1;
            let findIndex = next.findIndex(x => {
              return x.id === pushObj.id;
            })
            if (findIndex > -1) {
              if (!next[findIndex].line) {
                console.log('what no line?', next[findIndex]);
              }
              if (!pushObj.line) {
                console.log('what no line?', pushObj);
              }
              let judge1 = this.noChange(next[findIndex].line, origin)
              let judge2 = this.noChange(pushObj.line, origin)
              if (judge1 && !judge2) {

              } else if (!judge1 && judge2) {
                next[findIndex] = pushObj
              } else {
                next[findIndex].line = Array.from(new Set((next[findIndex].line + '|' + pushObj.line).split('|'))).join(
                  '|');
              }
            } else {
              next.push(pushObj);
            }
          }
        }
        // console.log('next', next);
        return next;
      },
      noChange(line1, line2) {
        // console.log('line1 line2',line1,line2)
        let arr1 = line1.split('|');
        let arr2 = line2.split('|');
        for (let i = 0; i < arr1.length; i++) {
          for (let k = 0; k < arr2.length; k++) {
            if (arr1[i] === arr2[k]) {
              return true;
            }
          }
        }
        return false;
      },

      // 地铁站关联1公里内的重点配套
      hcahcwefks() {
        this.$open();
        let that = this;
        that.$axios.get(that.$url_prefix + 'subwayGoto').then(res => {
          let stationList = res.data.data.stationList;
          that.stationList = JSON.parse(JSON.stringify(stationList));
          that.subwayList = res.data.data.subwayList;
          // console.log('that.subwayList', that.subwayList);
          that.chahclsehcx(stationList, res.data.data.locationList, {});
        })
      },
      async chahclsehcx(list, base, nearObj) {
        if (list.length === 0) {
          console.log('nearObj', nearObj);
          this.fxhakchebga(nearObj);
          return;
        }
        let theOne = list.splice(0, 1)[0];
        if (!theOne.lnglat) {
          this.chahclsehcx(list, base, nearObj);
          return;
        }
        let nearby = [];
        for (let i = 0, len = base.length; i < len; i++) {
          if (base[i].lnglat) {
            let temp = this.getClosestDot(theOne.lnglat, base[i].lnglat);
            if (temp.distance < 800) {
              nearby.push({
                id: base[i].id,
                location_name: base[i].location_name,
                distance: temp.distance
              })
              // let location_data = await this.$planRoute(theOne.lnglat, base[i].lnglat)
              // if (location_data.walking.distance <= 1000) {
              //   nearby.push({
              //     id: base[i].id,
              //     location_name: base[i].location_name,
              //     distance: location_data.walking.distance
              //   })
              // }
            }
          }
        }
        if (nearby.length === 0) {
          this.chahclsehcx(list, base, nearObj);
          return;
        }
        nearObj[theOne.id] = nearby;
        this.chahclsehcx(list, base, nearObj);
      },
      getClosestDot(a, b) {
        let lista = a.split('-')
        let listb = b.split('-')
        let dota = lista[0].split('|')
        let dotb = listb[0].split('|')
        let distance = this.getDistance(Number(dota[1]), Number(dota[0]), Number(dotb[1]), Number(dotb[0]))
        for (let i = 0; i < lista.length; i++) {
          for (let j = 0; j < listb.length; j++) {
            let pointa = lista[i].split('|')
            let pointb = listb[j].split('|')
            let temp = this.getDistance(Number(pointa[1]), Number(pointa[0]), Number(pointb[1]), Number(pointb[
              0]))
            if (temp < distance) {
              distance = temp
              dota = pointa
              dotb = pointb
            }
          }
        }
        return {
          a: dota,
          b: dotb,
          distance: parseInt(distance)
        }
      },
      getDistance(lat1, lng1, lat2, lng2) {
        let EARTH_RADIUS = 6378137.0; //单位M
        let f = this.getRad((lat1 + lat2) / 2);
        let g = this.getRad((lat1 - lat2) / 2);
        let l = this.getRad((lng1 - lng2) / 2);

        let sg = Math.sin(g);
        let sl = Math.sin(l);
        let sf = Math.sin(f);

        let s, c, w, r, d, h1, h2;
        let a = EARTH_RADIUS;
        let fl = 1 / 298.257;

        sg = sg * sg;
        sl = sl * sl;
        sf = sf * sf;

        s = sg * (1 - sl) + (1 - sf) * sl;
        c = (1 - sg) * (1 - sl) + sf * sl;

        w = Math.atan(Math.sqrt(s / c));
        r = Math.sqrt(s * c) / w;
        d = 2 * w * a;
        h1 = (3 * r - 1) / 2 / c;
        h2 = (3 * r + 1) / 2 / s;

        return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
      },
      getRad(d) {
        let PI = Math.PI;
        return d * PI / 180.0;
      },


      setNearReals() { // 楼盘的周边楼盘, 一手 二手 各限制3个
        let list = JSON.parse(JSON.stringify(this.realList));
        let newReals = JSON.parse(JSON.stringify(this.realList));
        let oldReals = JSON.parse(JSON.stringify(this.oldRealList));
        this.$open();
        this.chhchsehxchhes(list, newReals, oldReals);
      },
      chhchsehxchhes(list, newReals, oldReals) {
        let that = this;
        if (list.length === 0) {
          this.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let radius = 1000;
        let nearNew = [];
        let nearOld = [];
        let thePriceKeys = [];
        if (theOne.real_estate_des) {
          let des = JSON.parse(theOne.real_estate_des);
          if (des.onprices) {
            thePriceKeys = Object.keys(des.onprices);
          }
        }
        for (let i = 0; i < newReals.length; i++) {
          if (!newReals[i].lnglat) {
            console.log('么有经纬度', newReals[i])
            continue
          }
          if (newReals[i].id === theOne.id || newReals[i].real_status === '售罄' ||
            newReals[i].build_type === '商住' || !newReals[i].real_estate_des) {
            continue;
          }
          let des = JSON.parse(newReals[i].real_estate_des);
          if (des && des.onprices) {
            let judge = false;
            let priceKeys = Object.keys(des.onprices);
            for (let k = 0; k < priceKeys.length; k++) {
              if (thePriceKeys.includes(priceKeys[k])) {
                judge = true;
                break
              }
            }
            if (judge) {
              let temp = this.getClosestDot(theOne.lnglat, newReals[i].lnglat)
              if (temp.distance <= radius) {
                nearNew.push(newReals[i].id);
              }
            }
          }
        }
        for (let i = 0; i < oldReals.length; i++) {
          if (!oldReals[i].lnglat) {
            console.log('么有经纬度', oldReals[i])
            continue
          }
          if (!oldReals[i].real_estate_des) {
            continue;
          }
          let des = JSON.parse(oldReals[i].real_estate_des);
          if (!des.deal_price) {
            continue
          }
          let temp = this.getClosestDot(theOne.lnglat, oldReals[i].lnglat)
          if (temp.distance <= radius) {
            nearOld.push(oldReals[i])
          }
        }

        let obj = {
          id: theOne.id
        }
        if (nearNew.length === 0 && nearOld.length === 0) {
          obj.nearby = '';
        } else {
          let nearby = {};
          if (nearNew.length > 0) {
            nearby.new = nearNew.slice(0, 3);
          }
          if (nearOld.length > 0) {
            nearOld.sort((a, b) => {
              let priceA = parseInt(JSON.parse(a.real_estate_des).deal_price),
                priceB = parseInt(JSON.parse(b.real_estate_des).deal_price);
              return priceB - priceA;
            });
            let temp = nearOld.slice(0, 3);
            for (let i = 0; i < temp.length; i++) {
              temp[i] = temp[i].id;
            }
            nearby.old = temp;
          }
          obj.nearby = JSON.stringify(nearby);
        }

        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.chhchsehxchhes(list, newReals, oldReals)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.chhchsehxchhes(list, newReals, oldReals)
        })
      },

      shefasehfa() { // 自住配套在本区域内排名
        let obj = {};
        this.$open();
        let list = this.realList.filter(x => {
          return x.real_status !== '售罄' && x.build_type !== '商住';
        });
        for (let i = 0; i < list.length; i++) {
          let real = list[i];
          if (real.label2) {
            let label2 = JSON.parse(real.label2);
            if (label2.area_label) {
              let str = label2.area_label.split('|')[0];
              if (obj[str]) {
                obj[str].push(real);
              } else {
                obj[str] = [real];
              }
            }
          }
        }
        for (let key in obj) {
          obj[key].sort((a, b) => {
            let numa = parseFloat(a.location_level) || 0;
            let numb = parseFloat(b.location_level) || 0;
            let viewa = a.views_num || 0;
            let viewb = b.views_num || 0;
            if (numa === numb) {
              return viewb - viewa;
            }
            return numb - numa;
          })
        }
        // console.log('obj', obj);
        this.clasefhpxhae(list, obj);
      },
      clasefhpxhae(list, sortObj) {
        let that = this;
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let str = '';
        if (theOne.label2) {
          let label2 = JSON.parse(theOne.label2);
          if (label2.area_label) {
            str = label2.area_label.split('|')[0];
          }
        }
        let index = -1;
        if (str) {
          index = sortObj[str].findIndex(x => {
            return x.id === theOne.id
          })
        }

        let obj = {
          id: theOne.id,
          area_label: str + '第' + (index + 1)
        }
        if (index === -1) {
          obj = {
            id: theOne.id,
            area_label: ''
          }
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.clasefhpxhae(list, sortObj);
        }).catch(function (res) {
          console.log('上传失败', res)
          that.clasefhpxhae(list, sortObj);
        })
      },

      chshexseh() { // 设置利率
        let that = this;
        let result = {
          shang1: 5.39,
          gong1: 3.25,
          shang2: 5.64,
          gong2: 3.25
        }
        let temp = {
          id: 'x3ksax090u',
          data: JSON.stringify(result)
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(temp)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传', res)
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      setStatement() { // 设置免责申明
        let that = this;
        let words = `第1条:"小鸡楼市"为小鸡数据科技有限公司（以下简称本公司）注册商标，任何人未经本公司许可不得以任何形式擅自使用。
        第2条:"小鸡楼市小程序"是本公司向用户提供的信息存储空间，为用户提供讨论、交流的平台。
        第3条:"小鸡楼市小程序"所有权、经营权、管理权均属本公司。
        第4条:本公司在法律允许的范围内对本声明享有解释权。
        第5条:凡是登入用户和浏览用户均为"小鸡楼市小程序"用户(以下统称"用户")。
        第6条:用户的个人信息受到保护，不接受任何个人或单位的查询。国家机关依法查询除外，用户的个人设置公开除外。
        第7条:用户具有言论自由的权利。
        第8条:用户的言行不得违反《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《维护互联网安全的决定》、《互联网新闻信息服务管理规定》等相关法律规定，不得在本小程序发布、传播或以其它方式传送含有下列内容之一的信息:
        1.反对宪法所确定的基本原则的。
        2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。
        3.损害国家荣誉和利益的。
        4.煽动民族仇恨、民族歧视、破坏民族团结的。
        5.破坏国家宗教政策，宣扬邪教和封建迷信的。
        6.散布谣言，扰乱社会秩序，破坏社会稳定的。
        7.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。
        8.侮辱或者诽谤他人，侵害他人合法权利的。
        9.煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的。
        10.以非法民间组织名义活动的。
        11.含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容。
        12.含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。
        第9条:用户在相关楼盘发贴时，除遵守本声明外，还需遵守本小程序的相关规定。
        第10条:不允许在本小程序内发布任何形式的广告，包括但不限于:
        1.发布带有任何有联系方式的网络创业、网络兼职、刷Q币以及非真实性中奖信息;
        2.内容包含带有任何联系方式的学历职称代办，专业代做试题，作业，论文等题目以及售卖考试答案等信息;
        3.发布任何带有联系方式的银行卡代办、买卖发票、非法彩票等信息;
        4.含有联系方式的黑客、收费删帖、办证刻章等违法信息;
        5.非官方认证的发布任何带有联系方式的医院、美容、药品、祛斑、医生专家和整容等信息。
        第11条:用户应承担一切因其个人的行为而直接或间接导致的民事或刑事法律责任，因用户行为给本公司造成损失的，用户应负责赔偿。
        第12条:本小程序拥有对违反本站规则的用户进行处理的权力，直至禁止其在本小程序内发布信息。
        第13条:禁止任何使用发贴机等非法软件进行违规发贴的行为。
        第14条:任何用户发现小程序贴子内容涉嫌侮辱或者诽谤他人、侵害他人合法权益的或违反小程序声明的，有权按小程序投诉规则进行投诉。
        第15条:为了能够给广大用户提供一个优质的交流平台，同时使各小程序能够良性、健康的发展，将对涉及反动、色情的头像、签名档和发布不良内容的用户，进行严厉处理。一经发现此类行为，将给予永久封禁ID并清空所有发言的处罚。
        第16条:小程序评论仅代表作者观点，与本公司无关。对于用户言论的真实性引发的全部责任，由用户自行承担，本公司不承担任何责任。
        第17条:用户之间因使用"小鸡楼市小程序"而产生或可能产生的任何纠纷和/或损失，由用户自行解决并承担相应的责任，与本公司无关。
        第18条:用户在"小鸡楼市小程序"发表的作品，本公司有权转载或引用。
        第19条:用户在任何时间段在"小鸡楼市小程序"发表的任何内容的著作财产权，用户许可本公司在全世界范围内免费地、永久性地、不可撤销地、可分许可地和非独家地使用的权利，包括但不限于:复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及《著作权法》规定的由著作权人享有的其他著作财产权利。并且，用户许可本公司有权利就任何主体侵权而单独提起诉讼，并获得全部赔偿。
        第20条:本公司郑重提醒用户，若出现下列情况任意一种或几种，将承担删除其帐号的后果，情节严重的，还将承担相应的法律责任。
        1.使用不雅或不恰当ID和昵称;
        2.发表含有猥亵、色情、人身攻击和反政府言论等非法或侵权言论的;
        3.从事非法商业活动;
        4.模仿小程序管理人员ID或者他人ID，用以假冒管理人员或破坏管理人员形象;
        5.使用发贴机等非法软件进行违规发贴的行为。
        6.其他本公司认为不恰当的情况。
        第21条:凡文章出现以下情况之一，"小鸡楼市小程序"管理人员有权不提前通知作者直接删除，并依照有关规定作相应处罚。情节严重者，"小鸡楼市小程序"管理人员有权删除其帐号。
        1.发表含有本声明第8条禁止发布、传播内容的文章;
        2.发表不符合版面主题，或者无内容的灌水文章;
        3.同一文章多次出现的;
        4.违反本声明第10条的规定，发布广告的;
        5.文章内容或个人签名会包含有严重影响用户浏览的内容或格式的;
        6.其他本公司认为不恰当的情况。
        第22条:本声明的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。
        第23条若用户和小鸡之间因本声明发生任何纠纷或争议，首先应友好协商解决;协商不成的，用户同意将纠纷或争议提交至小鸡住所地有管辖权的人民法院管辖。
        第24条:关于打击网络谣言的司法解释:《最高人民法院、最高人民检察院关于办理利用信息网络实施诽谤等刑事案件适用法律若干问题的解释》已于2013年9月5日由最高人民法院审判委员会第1589次会议、2013年9月2日由最高人民检察院第十二届检察委员会第9次会议通过，现予公布，自2013年9月10日起施行。
        第25条:所有用户发表的文章而引起的法律纠纷，与本公司无关。
        第26条:"小鸡楼市小程序"如因系统维护或升级等而需暂停服务时，将事先公告。若因硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，本小程序不负任何责任。
        由于"小鸡楼市小程序"的调整导致信息丢失和/或其他结果的，本公司不承担任何责任。
        第27条:本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。`
        let temp = {
          id: 'o50c3j72cs',
          data: words
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(temp)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传', res)
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      cxsepaxecg() { // 给二手房绑定板块
        let that = this
        that.$open();
        let list = JSON.parse(JSON.stringify(this.oldRealList)) //所有楼盘
        this.cxehxpaefe(list)
      },
      cxehxpaefe(list) {
        let that = this
        if (list.length === 0) {
          that.$close()
          return;
        }
        let theOne = list.splice(0, 1)[0];
        if (!theOne.lnglat) {
          console.log('没有经纬度', theOne)
          that.cxehxpaefe(list);
          return;
        }
        let dot = theOne.lnglat.split('-')[0].split('|')
        let result = that.judgeArea(dot)
        if (!result) {
          // console.log('不属于任何板块', theOne)
          that.cxehxpaefe(list);
          return;
        }
        if (result.id === theOne.area_id) {
          that.cxehxpaefe(list);
          return;
        }
        let obj = {
          id: theOne.id,
          area_id: result.id
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.cxehxpaefe(list);
        }).catch(function (res) {
          that.cxehxpaefe(list);
          console.log('上传失败', res)
        })
      },

      cxsepcaxecg() { // 给新房绑定板块
        let that = this
        that.$open();
        let list = JSON.parse(JSON.stringify(this.realList)) //所有楼盘
        this.cxevkhxpaefe(list)
      },
      cxevkhxpaefe(list) {
        let that = this
        if (list.length === 0) {
          that.$close()
          return;
        }
        let theOne = list.splice(0, 1)[0];
        if (!theOne.lnglat) {
          console.log('没有经纬度', theOne)
          that.cxevkhxpaefe(list);
          return;
        }
        let dot = theOne.lnglat.split('-')[0].split('|')
        let result = that.judgeArea(dot)
        if (!result) {
          // console.log('不属于任何板块', theOne)
          that.cxevkhxpaefe(list);
          return;
        }
        if (result.id === theOne.area_id) {
          that.cxevkhxpaefe(list);
          return;
        }
        let obj = {
          id: theOne.id,
          area_id: result.id
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.cxevkhxpaefe(list);
        }).catch(function (res) {
          that.cxevkhxpaefe(list);
          console.log('上传失败', res)
        })
      },

      kxksefaxcwep() { // 复制一条备份
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: 'tcvu8uzi83',
            db: 'WpBackupModel'
          }
        }).then(function (res) {
          console.log('back', res)

          let temp = {
            name: '楼盘筛选套餐和标签',
            data: res.data.data.data
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(temp)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('上传', res)
          }).catch(function (res) {
            console.log('上传失败', res)
          })
        })

      },
      kxkdfxcwep: async function () { // 
        let that = this;
        let res = await that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: '2o7qovoiqci',
            db: 'WpBackupModel'
          }
        });
        let data = JSON.parse(res.data.data.data);
        let realRes = await that.$axios.get(that.$url_prefix + 'getOldReals1');
        let realList = realRes.data.data;
        let i=1;
        for (let key in data) {
          console.log('i',i);
          let lnglat = data[key].lnglat;
          let minDis = null;
          let minObj = null;
          for (let i=0; i<realList.length; i++) {
            let dis = that.getClosestDot(lnglat, realList[i].lnglat).distance;
            if (dis && (!minDis || dis<minDis)) {
              minDis = dis;
              minObj = realList[i];
            }
          }
          i++;
          data[key].name = minObj.real_estate_name;
          data[key].id = minObj.id;
          data[key].dis = minDis;
        }
        let obbj = {
          id: '2o7qovoiqci',
          data: JSON.stringify(data)
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obbj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新返回', res)
        }).catch(function (res) {
          console.log('更新失败', res)
        })
      },

      xshefnsefgv() { // 置业顾问积分迁移
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryUserInfo', {
          params: {
            user_id: '13avypogz76'
          }
        }).then(function (res) {
          console.log('query user back', res)
          let old = res.data.data;
          let obj = {
            id: '8s1a4kfp7o',
            activity: old.activity,
            contribute_score: old.contribute_score,
            dialog_share: old.dialog_share,
            form_id: old.form_id,
            history: old.history,
            praise_count: old.praise_count,
            praise_score: old.praise_score,
            praise_users: old.praise_users,
            share_score: old.share_score,
            share_users: old.share_users,
          }
          let param = {
            'db': 'WpUserModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('上传', res)
          }).catch(function (res) {
            console.log('上传失败', res)
          })
        }).catch(function (res) {
          console.log('query user fail', res)
        })

      },

      xsnxhfxeef() { // 更新控制性详细规划编号
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: '2i7i8jcx67q',
            db: 'WpBackupModel'
          }
        }).then(function (res) {
          let target = JSON.parse(res.data.data.data);
          console.log('target', target);
          // target.push([{
          //   num: 'T',
          //   name: '对外交通'
          // }])
          let obbj = {
            id: '2i7i8jcx67q',
            data: JSON.stringify(target)
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(obbj),
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新返回', res)
          }).catch(function (res) {
            console.log('更新失败', res)
          })
        })
      },

      lshogxcnehe() { // 改二手房价格
        let that = this;
        let id = '1glfgsvn4vq';
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: id,
            db: 'WpRealEstateModel'
          }
        }).then(function (res) {
          console.log('real info', res.data.data);
          // let ele = {
          //   id: id,
          //   real_estate_des: JSON.stringify({deal_price: 22865, hang_price: 23659})
          // }
          // let param = {
          //   'db': 'WpRealEstateModel',
          //   'model': 'edit',
          //   'item': JSON.stringify(ele)
          // }
          // that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          //   console.log('更新', res)
          // }).catch(function (res) {
          //   console.log('更新错误', res)
          // })
        })
      },

      sfcsjcpoygr() { // 首页的随机的标签
        let that = this;
        let temp = {
          id: '2k9y1avnmm4',
          data: JSON.stringify(['总价', '红盘', '倒挂', '地铁', '毛坯', '现房'])
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(temp)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传', res)
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      xxhfaef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getOneWant', {
          params: {
            want_id: ""
          }
        }).then(function (res) {
          console.log('query want back', res)
          let obj = res.data.data;
          let obbj = {
            id: obj.id,
            helpUsers: obj.helpUsers.concat(obj.helpUsers)
          }
          console.log('help', obbj);
          let param = {
            'db': 'WpWantModel',
            'model': 'edit',
            'item': JSON.stringify(obbj),
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新板块分类对象返回', res)
          }).catch(function (res) {
            console.log('更新板块分类对象失败', res)
          })
        }).catch(function (res) {
          console.log('query want fail', res)
        })
      },

      xhfalsehfsef() {
        let that = this;
        let obbj = {
          id: '1non9pmbd87',
          data: JSON.stringify([])
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obbj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新返回', res)
        }).catch(function (res) {
          console.log('更新失败', res)
        })
      },

      cshfewaxe() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'checkSunShare').then(function (res) {
          console.log('query want back', res)
          res.data.data.forEach(x => {
            if (x.helps > 0) {
              console.log(x);
            }
          })
        }).catch(function (res) {
          console.log('query want fail', res)
        })
      },

      optihonvhsef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryUserInfo', {
          params: {
            open_id: 'ovr7b4py33I7-VQy49u8cJ92M1lc'
          }
        }).then(function (res) {
          console.log('query want back', res)
        }).catch(function (res) {
          console.log('query want fail', res)
        })
      },

      opxfeonvhsef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'someoneShare', {
          params: {
            open_id: 'ovr7b4py33I7-VQy49u8cJ92M1lc'
          }
        }).then(function (res) {
          console.log('query want back', res.data.data.filter(x => {
            return x.estate_id === '2a4u2pq83wb';
          }))
        }).catch(function (res) {
          console.log('query want fail', res)
        })
      },

      chfselhvfae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryAreaPlanDetail', {
          params: {
            id: '12bg3vx20cp'
          }
        }).then((res) => {
          console.log('area plan', res);
          let list = res.data.landList;
          let total = 0;
          let dic = {};
          for (let i = 0, len = list.length; i < len; i++) {
            let path = list[i].dots.split('-').map(x => {
              return x.split('|');
            });
            let square = AMap.GeometryUtil.ringArea(path);
            total += square;
          }
          console.log('total', total);
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      hlxegfaesf() {
        let that = this;
        that.$open();
        that.$axios.get(that.$url_prefix + 'areaWithLandPlan').then((res) => {
          console.log('area plan', res);
          let areas = res.data.data.filter(x => {
            return x.lands.length > 0
          });
          that.xxfbalskef(areas);
        }).catch((res) => {
          console.log('fail', res);
        })
      },
      xxfbalskef(list) {
        let that = this;
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];

        let lands = theOne.lands.filter(x => {
          return x.cells.length > 0;
        })
        if (lands.length === 0) {
          return;
        }

        let total_s = 0;
        let total_n = 0;
        let industry = 0;
        let dic = {};
        // school(nine nursery college) business live produce
        for (let k = 0; k < lands.length; k++) {
          let cells = lands[k].cells;
          for (let i = 0, len = cells.length; i < len; i++) {
            let path = cells[i].dots.split('-').map(x => {
              return x.split('|');
            });
            let square = AMap.GeometryUtil.ringArea(path);
            total_s += square;
            total_n += 1;
            let type = cells[i].type;
            if (type.includes('R22')) { // 幼儿园
              if (!dic.school) {
                dic.school = {}
              }
              if (!dic.school.nursery) {
                dic.school.nursery = {};
              }
              dic.school.nursery.square = (dic.school.nursery.square || 0) + square;
              dic.school.nursery.num = (dic.school.nursery.num || 0) + 1;
            }
            if (type.includes('A33')) { // 中小学
              if (!dic.school) {
                dic.school = {}
              }
              if (!dic.school.nine) {
                dic.school.nine = {};
              }
              dic.school.nine.square = (dic.school.nine.square || 0) + square;
              dic.school.nine.num = (dic.school.nine.num || 0) + 1;
            }
            if (type.includes('A31') || type.includes('A32')) { // 大学中专
              if (!dic.school) {
                dic.school = {}
              }
              if (!dic.school.college) {
                dic.school.college = {};
              }
              dic.school.college.square = (dic.school.college.square || 0) + square;
              dic.school.college.num = (dic.school.college.num || 0) + 1;
            }

            if (type.includes('R') && !type.includes('R22')) { // 住宅
              if (!dic.live) {
                dic.live = {};
              }
              dic.live.square = (dic.live.square || 0) + square;
              dic.live.num = (dic.live.num || 0) + 1;
            }

            if (type.includes('B') || type.includes('C')) { // 商业商务
              if (!dic.business) {
                dic.business = {};
              }
              dic.business.square = (dic.business.square || 0) + square;
              dic.business.num = (dic.business.num || 0) + 1;
              industry += square;
            } else if (type.includes('M')) { // 工业用地
              industry += square;
              if (!dic.produce) {
                dic.produce = {}
              }
              if (type.includes('M2')) { // 二类
                if (!dic.produce.m2) {
                  dic.produce.m2 = {};
                }
                dic.produce.m2.square = (dic.produce.m2.square || 0) + square;
                dic.produce.m2.num = (dic.produce.m2.num || 0) + 1;
              } else {
                if (!dic.produce.m1) {
                  dic.produce.m1 = {};
                }
                dic.produce.m1.square = (dic.produce.m1.square || 0) + square;
                dic.produce.m1.num = (dic.produce.m1.num || 0) + 1;
              }
            }
          }
        }
        if (dic.school) {
          if (dic.school.nine) {
            dic.school.nine.rate = ((dic.school.nine.square / total_s) * 100).toFixed(1) + '%';
            dic.school.nine.square = (dic.school.nine.square / 10000).toFixed(1) + '万方';
          }
          if (dic.school.college) {
            dic.school.college.rate = ((dic.school.college.square / total_s) * 100).toFixed(1) + '%';
            dic.school.college.square = (dic.school.college.square / 10000).toFixed(1) + '万方';
          }
          if (dic.school.nursery) {
            dic.school.nursery.rate = ((dic.school.nursery.square / total_s) * 100).toFixed(1) + '%';
            dic.school.nursery.square = (dic.school.nursery.square / 10000).toFixed(1) + '万方';
          }
        }
        if (dic.produce) {
          if (dic.produce.m1) {
            dic.produce.m1.rate = ((dic.produce.m1.square / total_s) * 100).toFixed(1) + '%';
            dic.produce.m1.square = (dic.produce.m1.square / 10000).toFixed(1) + '万方';
          }
          if (dic.produce.m2) {
            dic.produce.m2.rate = ((dic.produce.m2.square / total_s) * 100).toFixed(1) + '%';
            dic.produce.m2.square = (dic.produce.m2.square / 10000).toFixed(1) + '万方';
          }
        }
        if (dic.business) {
          dic.business.rate = ((dic.business.square / total_s) * 100).toFixed(1) + '%';
          dic.business.square = (dic.business.square / 10000).toFixed(1) + '万方';
        }
        if (dic.live) {
          dic.live.rate = ((dic.live.square / total_s) * 100).toFixed(1) + '%';
          dic.live.square = (dic.live.square / 10000).toFixed(1) + '万方';
        }

        let obj = {
          id: theOne.id,
          landPlan: JSON.stringify({
            square: (total_s / 10000).toFixed(0) + '万方',
            num: total_n,
            cells: dic,
            industry: {
              square: Math.round(industry / 10000),
              rate: ((industry / total_s) * 100).toFixed(1) + '%'
            }
          })
        }
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.xxfbalskef(list);
        }).catch(function (res) {
          console.log('更新失败', res)
          that.xxfbalskef(list);
        })
      },

      hhhhhhhhhh() { // 分析楼盘周边3公里内的用地规划
        let that = this;
        that.$open();
        that.$axios.get(that.$url_prefix + 'toSetEstateLand').then((res) => {
          let result = res.data.data;
          let realList = result.realList;
          that.schapsefaef(realList, result.cells, result.officeList, result.marketList, result.stationList, result
            .lines4List);
        }).catch((res) => {
          console.log('fail', res);
        })
      },
      schapsefaef(list, cells, officeList, marketList, stationList, lines4List) {
        let that = this;
        let limitD = 3000;
        if (list.length === 0) {
          console.log('结束');
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let lnglat = theOne.lnglat.split('-')[0];

        let around = [];
        for (let i = 0, len = cells.length; i < len; i++) {
          let oneCell = JSON.parse(JSON.stringify(cells[i]));
          let dis = this.getClosestDot(lnglat, oneCell.dots.split('-')[0]).distance;
          if (dis < limitD) {
            oneCell.dis = dis;
            around.push(oneCell);
          }
        }

        let total_s = 0;
        let total_n = 0;
        let dic = {};
        let score = 0;
        for (let i = 0, len = around.length; i < len; i++) {
          let type = around[i].type;
          let path = around[i].dots.split('-').map(x => {
            return x.split('|');
          });
          let square = AMap.GeometryUtil.ringArea(path);
          let value = square * (1 - around[i].dis / 6250);
          total_s += square;
          total_n += 1;

          if (type.includes('B') || type.includes('C')) { // 商业商务
            if (!dic.industry) {
              dic.industry = {};
            }
            if (!dic.industry.business) {
              dic.industry.business = {};
            }
            dic.industry.business.square = (dic.industry.business.square || 0) + square;
            dic.industry.business.num = (dic.industry.business.num || 0) + 1;
            score += value;
          } else if (type.includes('M')) { // 工业用地
            if (!dic.industry) {
              dic.industry = {}
            }
            if (!dic.industry.produce) {
              dic.industry.produce = {};
            }
            dic.industry.produce.square = (dic.industry.produce.square || 0) + square;
            dic.industry.produce.num = (dic.industry.produce.num || 0) + 1;
            if (type.includes('M1')) {
              score += (value * 0.8);
            } else {
              score += (value * 0.6);
            }
          }
        }

        if (dic.industry) {
          dic.industry.sum = {};
          if (dic.industry.business) {
            dic.industry.sum.square = dic.industry.business.square;
            dic.industry.sum.num = dic.industry.business.num;
            dic.industry.business.square = (dic.industry.business.square / 10000).toFixed(1) + '万方';
          }
          if (dic.industry.produce) {
            dic.industry.sum.square = (dic.industry.sum.square || 0) + dic.industry.produce.square;
            dic.industry.sum.num = (dic.industry.sum.num || 0) + dic.industry.produce.num;
            dic.industry.produce.square = (dic.industry.produce.square / 10000).toFixed(1) + '万方';
          }
          dic.industry.sum.rate = ((dic.industry.sum.square / total_s) * 100).toFixed(1) + '%';
          dic.industry.sum.square = (dic.industry.sum.square / 10000).toFixed(1);
        }

        // 上市企业
        let ex = [];
        for (let i = 0; i < officeList.length; i++) {
          let dis = this.getClosestDot(lnglat, officeList[i].lnglat).distance;
          if (dis < limitD) {
            ex.push(officeList[i].short || officeList[i].location_name);
          }
        }

        // 商场规模
        let market_s = 0;
        for (let i = 0; i < marketList.length; i++) {
          if (marketList[i].location_size) {
            let dis = this.getClosestDot(lnglat, marketList[i].lnglat).distance;
            if (dis < limitD) {
              market_s += parseFloat(marketList[i].location_size);
            }
          }
        }

        // 地铁站数
        let station = 0;
        for (let i = 0; i < stationList.length; i++) {
          let dis = this.getClosestDot(lnglat, stationList[i].lnglat).distance;
          if (dis < limitD) {
            station++;
          }
        }
        for (let i = 0; i < lines4List.length; i++) {
          let lines4Station = JSON.parse(lines4List[i].station);
          lines4Station.forEach(x => {
            let dis = this.getClosestDot(lnglat, x.position.join('|')).distance;
            if (dis < limitD) {
              station++;
            }
          })
        }

        let result = {
          square: (total_s / 10000).toFixed(0) + '万方',
          num: total_n,
          cells: dic,
          score: parseInt(score / 10000),
          company: ex.length,
          market_s: Math.round(market_s),
          station: station
        }

        let obj = {
          id: theOne.id,
          landPlan: JSON.stringify(result)
        }

        console.log(result.num)
        // that.schapsefaef(list, cells, officeList, marketList, stationList, lines4List);

        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.schapsefaef(list, cells, officeList, marketList, stationList, lines4List);
        }).catch(function (res) {
          console.log('更新失败', res)
          that.schapsefaef(list, cells, officeList, marketList, stationList, lines4List);
        })
      },

      areaLandPlan() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'toSetAreaLand').then((res) => {
          let result = res.data.data;
          let cells = result.cells;
          for (let i = 0; i < cells.length; i++) {
            cells[i].dots = cells[i].dots.split('-').map(x => x.split('|'));
          }
          let areaList = result.areaList;
          let officeList = result.officeList;
          for (let i = 0; i < officeList.length; i++) {
            officeList[i].lnglat = officeList[i].lnglat.split('-')[0].split('|');
          }
          console.log('start');
          that.schalandaef(areaList, cells, officeList);
        }).catch((res) => {
          console.log('fail', res);
        })
      },
      schalandaef(list, cells, officeList) {
        let that = this;
        if (list.length === 0) {
          console.log('结束');
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let bounds = theOne.dots.split('-').map(x => {
          return x.split('|');
        })
        let around = [];
        for (let i = 0, len = cells.length; i < len; i++) {
          if (AMap.GeometryUtil.isPointInRing(cells[i].dots[0], bounds)) {
            around.push(cells[i]);
          }
        }

        if (around.length === 0) {
          that.schalandaef(list, cells, officeList);
          return;
        }

        let total_s = 0;
        let total_n = 0;
        let dic = {};
        let liveSquare = 0;
        for (let i = 0, len = around.length; i < len; i++) {
          let type = around[i].type;
          let square = AMap.GeometryUtil.ringArea(around[i].dots);
          total_s += square;
          total_n += 1;

          if (type.includes('R') && !type.includes('R22')) {
            liveSquare += square;
          } else if (type.includes('B') || type.includes('C')) { // 商业商务
            if (!dic.industry) {
              dic.industry = {};
            }
            if (!dic.industry.business) {
              dic.industry.business = {};
            }
            dic.industry.business.square = (dic.industry.business.square || 0) + square;
            dic.industry.business.num = (dic.industry.business.num || 0) + 1;
          } else if (type.includes('M')) { // 工业用地
            if (!dic.industry) {
              dic.industry = {}
            }
            if (!dic.industry.produce) {
              dic.industry.produce = {};
            }
            dic.industry.produce.square = (dic.industry.produce.square || 0) + square;
            dic.industry.produce.num = (dic.industry.produce.num || 0) + 1;
          }
        }

        let liveToWork = null;
        if (dic.industry) {
          dic.industry.sum = {};
          if (dic.industry.business) {
            dic.industry.sum.square = dic.industry.business.square;
            dic.industry.sum.num = dic.industry.business.num;
            dic.industry.business.square = (dic.industry.business.square / 10000).toFixed(1) + '万方';
          }
          if (dic.industry.produce) {
            dic.industry.sum.square = (dic.industry.sum.square || 0) + dic.industry.produce.square;
            dic.industry.sum.num = (dic.industry.sum.num || 0) + dic.industry.produce.num;
            dic.industry.produce.square = (dic.industry.produce.square / 10000).toFixed(1) + '万方';
          }
          liveToWork = (liveSquare / dic.industry.sum.square).toFixed(2);
          dic.industry.sum.rate = ((dic.industry.sum.square / total_s) * 100).toFixed(1) + '%';
          dic.industry.sum.square = (dic.industry.sum.square / 10000).toFixed(1);
        }

        // 重点企业
        let ex = [];
        for (let i = 0; i < officeList.length; i++) {
          if (AMap.GeometryUtil.isPointInRing(officeList[i].lnglat, bounds)) {
            ex.push(officeList[i].short || officeList[i].location_name);
          }
        }

        let result = {
          square: (total_s / 10000).toFixed(0) + '万方',
          num: total_n,
          cells: dic,
          liveToWork: liveToWork
        }
        if (ex.length > 0) {
          result.company = ex.length;
          result.ex = ex;
        }

        let obj = {
          id: theOne.id,
          landPlan: result
        }

        console.log(result.num)
        // that.schalandaef(list, cells, officeList);

        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.schalandaef(list, cells, officeList);
        }).catch(function (res) {
          console.log('更新失败', res)
          that.schalandaef(list, cells, officeList);
        })
      },


      xhfhfvsea() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id landPlan real_estate_name'
          }
        }).then((res) => {
          let list = [];
          let realList = res.data.data;
          for (let i = 0, len = realList.length; i < len; i++) {
            if (realList[i].landPlan) {
              let land = JSON.parse(realList[i].landPlan);
              realList[i].landPlan = land;
              list.push(realList[i]);
            }
          }
          list.sort((a, b) => {
            return b.landPlan.industry - a.landPlan.industry;
          })
          console.log('list', list);
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      xfhaefabvb() {
        let ws = new WebSocket('wss://www.xaoji.com:443');
        ws.onopen = () => {
          console.log('连接');
        }
        ws.onerror = (err) => {
          console.log('err', err);
        }
      },


      cvsefncncvase() { // getDB
        let that = this;
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpSellpublicModel'
        //   }
        // }).then(function (res) {
        //   console.log('sellpublic', res.data.data)
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpUpdateRecordModel'
        //   }
        // }).then(function (res) {
        //   console.log('update record', res.data.data);
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpInviteModel'
        //   }
        // }).then(function (res) {
        //   console.log('WpInviteModel', res.data.data)
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpSelfEstateModel'
        //   }
        // }).then(function (res) {
        //   console.log('WpSelfEstateModel', res.data.data)
        //   let list = res.data.data;
        //   for (let i=0; i<list.length; i++) {
        //     if (list[i].estate_ad) {
        //       if (Object.keys(list[i].estate_ad).length > 0) {
        //         console.log(list[i]);
        //       }
        //     }
        //   }
        //   // console.log('list', list);
        //   // that.$axios.post(that.$url_prefix + 'delete', {
        //   //   'db': 'WpSelfEstateModel',
        //   //   'items': JSON.stringify(list)
        //   // }).then(function (res) {
        //   //   console.log('删除fanhui', res)
        //   // }).catch(function (res) {
        //   //   console.log('删除地段失败', res)
        //   // })
        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpNewsModel'
        //   }
        // }).then(function (res) {
        //   let list = res.data.data.filter(x => {
        //     return x.user_id === "008153";
        //   })
        //   console.log('WpNewsModel', list);

        // })
        // that.$axios.get(that.$url_prefix + 'getDB', {
        //   params: {
        //     dataContent: 'WpImageModel'
        //   }
        // }).then(function (res) {
        //   console.log('WpImageModel', res.data.data);
        // })
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'LandDealModel'
          }
        }).then(function (res) {
          let list = res.data.data
          console.log('LandDealModel', list)
          let obj = {};
          for (let i = 0; i < list.length; i++) {
            let square = list[i].squareJ;
            if (!obj[square]) {
              obj[square] = [];
            }
            obj[square].push(list[i].number);
          }
          let result = [];
          for (let key in obj) {
            if (obj[key].length > 1) {
              result.push(obj[key]);
            }
          }
          console.log('result', result);
        })
      },
      xhfalsefase(list) {
        let that = this;
        if (list.length === 0) {
          console.log('jieshu');
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let obj = {
          id: theOne.id,
          estate_id: '1swik4wkcdb'
        }
        let param = {
          'db': 'WpImageModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.xhfalsefase(list);
        }).catch(function (res) {
          console.log('更新失败', res)
          that.xhfalsefase(list);
        })
      },



      chflehfaefx() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'tempOperation').then((res) => {
          console.log('success');
        })
      },

      hhvhhasfhhse() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id base_info'
          }
        }).then((res) => {
          let realList = res.data.data.filter(x => x.base_info);
          console.log(realList);
        }).catch((res) => {
          console.log('fail', res);
        })
      },


      sefbflasef() { // 改变所有置业顾问的属性
        let that = this;
        let data = {
          'dataContent': 'WpUserModel'
        }
        that.$axios.get(that.$url_prefix + 'getDataByModel', {
          params: data
        }).then(function (res) {
          let list = res.data.data;
          let obj = {};
          for (let i = 0; i < list.length; i++) {
            if (obj[list[i].open_id]) {
              console.log('重复', list[i], obj[list[i].open_id])
            } else {
              obj[list[i].open_id] = list[i];
            }
          }
          console.log('over');
          // that.$open();
          // that.hhfvsefhaef(list)

        }).catch((res) => {
          console.log('fail', res);
        })
      },
      hhfvsefhaef(list) {
        let that = this;
        // console.log('listtt', list);
        if (list.length === 0) {
          that.$close();
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let obj = {
          id: theOne.id,
          week: {},
          user_type: '置业顾问',
          estates: ['2eyiyt7cqch']
        }
        let param = {
          'db': 'WpUserModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.hhfvsefhaef(list)
        }).catch(function (res) {
          console.log('更新错误', res)
          that.hhfvsefhaef(list)
        })
      },

      sfaesfcnsea() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: 'e6zq8zn4ho',
            db: 'WpBackupModel'
          }
        }).then(function (res) {
          console.log('back', JSON.parse(res.data.data.data));
        })
      },

      sahcvasefh() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'WpImageModel'
          }
        }).then(function (res) {
          let list = res.data.data;
          // let list = res.data.data.filter(x => {
          //   return x.status;
          // })
          console.log('list', list);
          // that.xbfalsefx(list);
          // that.$axios.post(that.$url_prefix + 'delete', {
          //   'db': 'WpNewsModel',
          //   'items': JSON.stringify(list)
          // }).then(function (res) {
          //   console.log('删除fanhui', res)
          // }).catch(function (res) {
          //   console.log('删除地段失败', res)
          // })
        })
      },
      xbfalsefx(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let one = list.splice(0, 1)[0];
        let obj = {
          id: one.id,
          status: ''
        }
        let param = {
          'db': 'WpImageModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          console.log('back', res);
          that.xbfalsefx(list);
        }).catch(res => {
          console.log('fail', res);
          that.xbfalsefx(list);
        })
      },

      hfbasefhbcxfase() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id real_estate_des'
          }
        }).then((res) => {
          let list = res.data.data.filter(x => {
            if (x.real_estate_des) {
              let des = JSON.parse(x.real_estate_des);
              if (des.datesTime_yuji) {
                return true;
              }
            }
          });
          console.log('list', list);
          that.fhxfasef(list);
        }).catch((res) => {
          console.log('get new reals fail', res);
        })
      },
      fhxfasef(list) {
        let that = this;
        if (list.length === 0) {
          return;
        }
        let theOne = list.splice(0, 1)[0];
        let des = JSON.parse(theOne.real_estate_des);
        let obj = {
          id: theOne.id,
          expect: {
            date: des.datesTime_yuji
          }
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.fhxfasef(list)
        }).catch(function (res) {
          console.log('更新地段错误', res)
          that.fhxfasef(list)
        })
      },

      hvalsefvase() { // 调试
        let that = this;
        that.$axios.get(that.$url_prefix + 'xuhaiqiang').then((res) => {
          console.log('res', res);
          // window.open('https://www.xaoji.com/upload/image/vrview.html?info=' + JSON.stringify(res.data.data));
        });
      },
      dfhhsefae(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let obj = list.splice(0, 1)[0];
        obj.special = true;
        let param = {
          'db': 'WpUserModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.dfhhsefae(list);
        }).catch(function (res) {
          that.dfhhsefae(list);
        })
      },

      hvhlshalefs() { // 改用户
        let that = this;
        // let obj = {
        //   id: "008153",
        //   estates: ['uxlxer90kj'],
        // }
        // let param = {
        //   'db': 'WpUserModel',
        //   'model': 'edit',
        //   'item': JSON.stringify(obj)
        // }

        let obj = {
          id: "41wnfibyot",
          estates: ['4g33nw14nj']
        }
        let param = {
          'db': 'SzUserModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }

        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新', res)
        }).catch(function (res) {
          console.log('更新错误', res)
        })
      },

      scgslefgase() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id real_estate_name real_estate_des'
          }
        }).then((res) => {
          let list = res.data.data;
          for (let i = 0; i < list.length; i++) {
            if (list[i].real_estate_des) {
              let des = JSON.parse(list[i].real_estate_des);
              if (des.buildNum && !des.buildNum.match) {
                console.log('有问题', list[i].real_estate_name);
              }
            }
          }
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      xhfsaefaefa() {
        let list = ['a', 'b', 'c', 'd', 'e'];
        console.log('list', list);
        list.splice(-1, 1);
        console.log('after', list);
      },

      lxasefcbea() {
        let obj = {
          first: 999
        }
        let obj2 = {
          other: 777
        }
        obj.second = obj2.first;
        console.log('obj', obj);
      },

      chalsefaxea() { // 把之前上传的图库保存为现在的格式
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id real_estate_name overview negative_factor room_price design_sketch around sand_table model_house apartment apartment_distribution realDisadverse realFactor'
          }
        }).then((res) => {
          let list = res.data.data.filter(x => {
            return x.negative_factor;
          });
          let images = JSON.parse(list[0].negative_factor);
          console.log('images', images);
        }).catch((res) => {
          console.log('fail', res);
        })
      },

      sfalshvgxsfae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'upload/image/ad_324462.jpeg').then(res => {
          console.log('back', res);
        }).catch(res => {
          console.log('err', res);
        })
      },

      fslefaefxhfe() {
        let that = this;

        that.$axios.get(that.$url_prefix + 'queryRealEstateDetail', {
          params: {
            real_estate_id: '095484'
          }
        }).then(res => {
          let realEstate = res.data.data.realEstate;
          let history = JSON.parse(realEstate.history);
          let des = JSON.parse(realEstate.real_estate_des);

          console.log('history', history);
          console.log('des', des);
        })
      },

      xncchvsef() {
        let that = this;
        let obj = {
          range: ['置业顾问'],
          words: '小鸡评分公众号的头条文章竞拍已上架，赶紧去竞拍！',
          images: ['https://www.xaoji.com:3001/upload/image/tmp_797f359b334c5a620cee94dad40cf824.jpg',
            'https://www.xaoji.com:3001/upload/image/tmp_c80d1bed74d1a2389e465b9c5c567fcd.jpg'
          ]
        }
        let param = {
          'db': 'WpSystemModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新', res)
        }).catch(function (res) {
          console.log('更新错误', res)
        })
      },

      sefahxfslef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals1', {
          params: {
            project: 'id'
          }
        }).then(res => {
          console.log('list', res.data.data);
          that.slhfalsefae(res.data.data)
        })
      },
      slhfalsefae(list) {
        let that = this;
        if (list.length === 0) {
          console.log('结束');
          return;
        }
        let one = list.splice(0, 1)[0];
        that.$axios.get(that.$url_prefix + 'debug', {
          params: {
            id: one.id
          }
        }).then(back => {
          that.slhfalsefae(list)
        }).catch(err => {
          console.log('err', err);
          that.slhfalsefae(list)
        })
      },


      sefhaghvfse() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'WpCollectModel'
          }
        }).then(function (res) {
          let list = res.data.data.filter(x => {
            return x.type === '置业顾问' && x.status === 1;
          });
          let all = {};
          list.forEach(x => {
            all[x.target] = (all[x.target] || 0) + 1
          })
          console.log('WpCollectModel', all);
          for (let key in all) {
            let obj = {
              id: key,
              follow: all[key]
            }
            let param = {
              'db': 'WpUserModel',
              'model': 'edit',
              'item': JSON.stringify(obj)
            }
            that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
              console.log('更新', res)
            }).catch(function (res) {
              console.log('更新错误', res)
            })
          }
        })
      },

      xxlhfasefaef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: '915200',
            db: 'WpAreaModel'
          }
        }).then(function (res) {
          console.log('query Back', res)
          let obj = {
            id: '915200',
            selfTrend: res.data.data.trend
          }
          let param = {
            'db': 'WpAreaModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新', res)
          }).catch(function (res) {
            console.log('更新错误', res)
          })
        })
      },

      xlsehfaefe() {
        let that = this;
        if (that.areaList.length === 0) {
          console.log('over');
          return;
        }
        let theOne = that.areaList.splice(0, 1)[0];
        let obj = {
          id: theOne.id,
          level: '板块'
        }
        let param = {
          'db': 'WpAreaModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新', res)
          that.xlsehfaefe();
        }).catch(function (res) {
          console.log('更新错误', res)
          that.xlsehfaefe();
        })
      },

      xlfshlhxlfae: async function () {
        let that = this;
        let bdary = new BMap.Boundary();
        // let lnglatList = await that.baiduSearch(bdary, '杭州市西湖区');
        // let dot = await that.baiduToAmap(lnglatList[0].split(', '));
        // let areaList = that.areaList;
        // for (let i=0; i<areaList.length; i++) {
        //   let area = areaList[i];
        //   let name = '杭州市' + area.area_name;
        //   let lnglatList = await that.baiduSearch(bdary, name);
        //   for (let k=0; k<lnglatList.length; k++) {
        //     let dot = await that.baiduToAmap(lnglatList[k].split(', '));
        //     lnglatList[k] = dot.lng + '|' + dot.lat;
        //   }
        //   console.log('name', lnglatList);
        // }
        bdary.get('杭州市', function (rs) {
          // let lnglatList = rs.boundaries[0].split(';');
          console.log('rs', rs);
        })
      },
      // 将百度地图的坐标转换为高德地图的坐标
      baiduToAmap: async function (dot) {
        let that = this
        return new Promise((resolve, reject) => {
          AMap.convertFrom(dot, 'baidu', function (status, result) {
            if (result.info === 'ok') {
              resolve(result.locations)
            } else {
              resolve('转换坐标失败')
            }
          });
        })
      },
      baiduSearch: async function (bdary, position) {
        let that = this
        return new Promise((resolve, reject) => {
          bdary.get(position, function (rs) {
            let lnglatList = rs.boundaries[0].split(';');
            resolve(lnglatList)
          })
        })
      },

      xlfhasefase(e) {
        let that = this;
        let ele = {
          user_id: '小鸡选房',
          estate_id: '467269',
          words: '3#，4#，选房顺序和日照评测已出',
          type: '楼盘评测'
        }
        let param = {
          'db': 'WpNewsModel',
          'model': 'edit',
          'item': JSON.stringify(ele)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('res', res)
        }).catch(function (err) {
          console.log('err', err)
        })
      },

      xlfhasxeefase(e) {
        let that = this;
        let ele = {
          id: '23mw4wbuqe9',
          type: '新房',
          lnglat: '120.982237|31.364034'
        }
        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(ele)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('res', res)
        }).catch(function (err) {
          console.log('err', err)
        })
      },

      xlfhasqase(e) {
        let that = this;
        let ele = {
          id: 'qi32jmlbbk',
          status: '评测失败',
          note: '未找到该楼盘的总平面图，可将总平面图发给小鸡微信',
        }
        let param = {
          'db': 'WpWantModel',
          'model': 'edit',
          'item': JSON.stringify(ele)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('res', res)
        }).catch(function (err) {
          console.log('err', err)
        })
      },

      xasexfaefaesfa(e) {
        let files = e.target.files;
        let fileReader = new FileReader();
        fileReader.onload = function (ev) {
          let str = ev.target.result
          let arr = str.split('Buddha');

          for (let i = 0; i < arr.length; i++) {
            let c = arr[i];
            let obj = null
            try {
              obj = JSON.parse(c);
            } catch (err) {
              console.log('err', err, c);
            }
            // if (obj) {
            //   console.log('obj', obj);
            // }
          }
        };
        fileReader.readAsText(files[0]);
      },
      xasefaesfa(e) {
        let files = e.target.files;
        let fileReader = new FileReader();
        fileReader.onload = function (ev) {
          let str = ev.target.result
          let arr = str.split(');');
          console.log('total', arr.length);
          let num = 0;
          let all = {};
          for (let i = 0; i < arr.length; i++) {
            let a = arr[i].trim();
            if (!a) {
              continue;
            }
            let c = a.replace(/ObjectId\("(\w+)"\)/, '{"$oid":"$1"}')
              .replace('db.wprealestatemodels.insert(', '')
              .replace('insert(', '')
              .replace(/NumberInt\("(\d+)"\)/g, '$1')
              //  .replace(/\\\\/g,'\\')
              //  .replace(/\\\\/g,'\\')
              .replace(/\\\\"/g, "'")
              .replace(/Number\("(\d+.\d+)"\)/g, '$1')
              .replace(/\n/g, '')
              .replace(/\s/g, '');
            let obj = null;
            try {
              obj = JSON.parse(c);
            } catch (err) {
              console.log('err', err, c);
              break;
            }
            if (obj) {
              num++;
              if (obj.real_estate_des) {
                try {
                  JSON.parse(obj.real_estate_des)
                } catch (error) {
                  console.log('error', error, obj.real_estate_des);
                  break;
                }
              }
            }
          }
          console.log('num', num);
        };
        fileReader.readAsText(files[0]);
      },

      lxfcvblasef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getNewReals').then(function (res) {
          let list = res.data.data;
          let total = 0;
          let errnum = 0;
          let errlist = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].base_info) {
              try {
                JSON.parse(list[i].base_info);
              } catch (err) {
                errlist.push(list[i])
              }

            }
          }
          console.log(total, errnum);
          console.log(errlist);
          that.shfalshefase(errlist);
        })
      },
      shfalshefase(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let one = list.splice(0, 1)[0];
        let obj = {
          id: one.id,
          base_info: one.base_info.replace(/\s/g, '')
        };

        let param = {
          'db': 'WpRealEstateModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.shfalshefase(list)
        }).catch(function (res) {
          console.log('上传失败', res)
          that.shfalshefase(list)
        })
      },

      xhhfhasehah() { // 增加ip
        let that = this;
        let id = 'f9zl9lgt3v';
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: id,
            db: 'WpBackupModel'
          }
        }).then(function (res) {
          console.log('query Back', res)
          let data = JSON.parse(res.data.data.data);
          data.push('::ffff:115.199.164.10')
          let obj = {
            id: id,
            data: JSON.stringify(data)
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新', res)
          }).catch(function (res) {
            console.log('更新错误', res)
          })
        })
      },

      sahcvfffasefh() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'WpCollectModel'
          }
        }).then(function (res) {
          let list = res.data.data.filter(x => {
            return x.status === 1 && x.type === '置业顾问';
          });
          let obj = {};
          for (let i = 0; i < list.length; i++) {
            obj[list[i].target] = (obj[list[i].target] || 0) + 1;
          }
          let result = [];
          for (let key in obj) {
            result.push({
              id: key,
              follow: obj[key]
            })
          }
          console.log(result);
          that.hxhflahesfae(result);
        })
      },
      hxhflahesfae(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let obj = list.splice(0, 1)[0];
        let param = {
          'db': 'WpUserModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新', res)
          that.hxhflahesfae(list);
        }).catch(function (res) {
          console.log('更新错误', res)
          that.hxhflahesfae(list);
        })
      },

      xhlaefe() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'WpSellpublicModel'
          }
        }).then(res => {
          let list = res.data.data.filter(x => {
            return x.status !== 'FINISH';
          });
          console.log('list', list);
        }).catch(err => {
          console.log('err', err);
        })
      },

      sfhaefax() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'checkAuction').then(res => {
          console.log('res', res);
          let list = res.data.data.filter(x => {
            return x.target && x.target !== "2eyiyt7cqch";
          })
          let obj = {};
          for (let i = 0; i < list.length; i++) {
            if (!obj[list[i].target]) {
              obj[list[i].target] = [];
            }
            obj[list[i].target].push(list[i]);
          }
          console.log(Object.keys(obj).length);
        }).catch(err => {
          console.log('err', err);
        })
      },


      sfhaeuuufax() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: '514140',
            db: 'WpAdModel'
          }
        }).then(function (res) {
          console.log('back', res)
          let obj = {
            id: res.data.data.id,
            ad_img: '客服:xaoji001https://www.xaoji.com:3001/upload/image/ad_267943.jpeg'
          }
          let param = {
            'db': 'WpAdModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            console.log('更新', res)
          }).catch(function (res) {
            console.log('更新错误', res)
          })
        })
      },

      xhfalefahef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'minifyImage').then(res => {
          console.log('res', res);
          // that.xhlaefae(res.data.data);
        }).catch(err => {
          console.log('err', err);
        })
      },
      xhlaefae(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let one = list.splice(0, 1)[0];
        that.$axios.get(that.$url_prefix + 'minifyOneImage', {
          params: {
            _id: one._id,
            url: one.url
          }
        }).then(res => {
          that.xhlaefae(list);
        }).catch(err => {
          console.log('err', err);
          that.xhlaefae(list);
        })
      },

      sfhaefasef() { // add note
        let that = this;
        that.$axios.get(that.$url_prefix + 'addSelfEstateNote', {
          params: {
            user_id: "8s1a4kfp7o",
            estate_id: "1efg23frajt"
          }
        }).then(res => {
          console.log('res', res);
        }).catch(err => {
          console.log('err', err);
        })
      },

      sfhaesssfasef() { // send message
        let that = this;
        that.$axios.get(that.$url_prefix + 'sendMessageTest').then(res => {
          console.log('res', res);
        }).catch(err => {
          console.log('err', err);
        })
      },

      parseBuilding() {
        let that = this;
        let temp = JSON.parse(this.testBuilding);
        console.log('temp', temp);
        // let obj = {
        //   id: '654846',
        //   building: JSON.stringify(temp)
        // }
        // let param = {
        //   'db': 'WpRealEstateModel',
        //   'model': 'edit',
        //   'item': JSON.stringify(obj),
        // }
        // that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
        //   console.log('更新板块分类对象返回', res)
        // }).catch(function (res) {
        //   console.log('更新板块分类对象失败', res)
        // })
      },

      hlhasefaec() {
        let one = parseInt(new Date('2020-01-01').getTime() / 1000);
        let oneday = 24 * 60 * 60;
        let arr = [];
        for (let i = 0; i < 30; i++) {
          arr.push(one + oneday * i);
        }
        let newday = parseInt(new Date('2020-01-31 23:59:30').getTime() / 1000);
        console.log('arr', arr.filter(x => {
          return x > (newday - oneday * 31)
        }))
      },


      xfhalefaef(e) {
        let that = this;
        let upload_file = e.target.files[0];
        let param = new FormData();
        param.append('film', upload_file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        that.$axios.post('img/uploadVideo', param, config).then(res => {
          console.log('res', res);
        }).catch(err => {
          console.log('err', err);
        })
      },


      cvsefncnxhacvase() { // getDB
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'WpMessageModel'
          }
        }).then(function (res) {
          let list = res.data.data;
          console.log('list', list);
          for (let i = 0; i < list.length; i++) {
            if (list[i].to_user === '20hgbvc7jnj') {
              console.log(list[i]);
            }
          }
        })
      },

      xhfaxhfaefae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'delOurNews').then(res => {
          console.log('del success');
        }).catch(err => {
          console.log('err', err);
        })
      },

      modifyOneAuction() { // 改竞拍
        let that = this;
        that.$axios.get(that.$url_prefix + 'debug').then((res) => {
          console.log('res', res.data.data.filter(x => {
            return x.record['26vv007gqm4'] && x.top.includes(String(x.record['26vv007gqm4'].price));
          }));
        });
      },


      shflasefhx() { // 改自己人openid
        let that = this;
        let id = '2ekcpk1z0n4';
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            db: 'WpBackupModel',
            id: id
          }
        }).then(res => {
          console.log('res', res);
          let data = JSON.parse(res.data.data.data);
          data.push('ovr7b4lAn4cRAirTMw0ls3GlJByU');
          // for (let i=0; i<data.length; i++) {
          //   if (data[i] === 'ovr7b4rjTVFKBZjE9klOBLXsOI7Y') {
          //     data.splice(i,1);
          //     break;
          //   }
          // }
          let obj = {
            id: id,
            data: JSON.stringify(data)
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            console.log('update back', res);
          })
        })
      },

      hxfaseefhx() { // 复制WpBackupModel
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: '1tsf9ttikym',
            db: 'WpBackupModel'
          }
        }).then(res => {
          console.log('res', res.data.data);
          let obj = {
            name: res.data.data.name,
            data: res.data.data.data
          }
          let param = {
            'db': 'WpBackupModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            console.log('update back', res);
          })
        })
      },

      lshf66alsefe() {
        let that = this;
        let data = {
          'dataContent': 'WpUserModel'
        }
        that.$axios.get(that.$url_prefix + 'getDataByModel', {
          params: data
        }).then(function (res) {
          let list = res.data.data.slice(1000);
          that.shxhfhaef(list);
        }).catch((res) => {
          console.log('fail', res);
        })
      },
      shxhfhaef(list) {
        let that = this;
        if (list.length === 0) {
          console.log('over');
          return;
        }
        let one = list.splice(0, 1)[0];
        that.$axios.get(that.$url_prefix + 'debug', {
          params: {
            id: one.id
          }
        }).then(res => {
          console.log('back', res.data.data);
          let timer = setTimeout(() => {
            that.shxhfhaef(list);
            clearTimeout(timer)
          }, 3000)
        }).catch(err => {
          console.log('fail', err);
          let timer = setTimeout(() => {
            that.shxhfhaef(list);
            clearTimeout(timer)
          }, 3000)
        })
      },

      shfahefae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getDB', {
          params: {
            dataContent: 'LandDealModel'
          }
        }).then(res => {
          let obj = {};
          let list = res.data.data;
          list.forEach(x => {
            obj[x.number] = (obj[x.number] || 0) + 1;
          })
          for (let key in obj) {
            if (obj[key] > 1) {
              console.log('重复土拍', key)
            }
          }
        })
      },

      hlahefasef() {
        let that = this;

        let obj = {
          id: "16nf4egb79k",
          real_estates: []
        }
        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          console.log('update back', res);
        })
      },

      delRegister() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'delRegister', {
          params: {
            name: '海逸翠廷里1、3、4幢',
            type: '意向登记'
          }
        }).then(res => {
          console.log('update back', res);
        })
      },
      // id: "2pzjk0fk784",
      delSellData() {
        let that = this;
        let obj = {
          id: "jpiahxu3gn",
          pre: '',
          result: [],
          name: ''
        }
        let param = {
          'db': 'WpSellpublicModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          console.log('update back', res);
        })
      },
      setRegister(e) {
        let that = this;
        let value = e.target.value;
        if (value) {
          e.target.value = '';
          e.target.blur();
          if (that.sell_id) {
            that.$axios.get(that.$url_prefix + 'setRegisterById', {
              params: {
                name: value,
                sell_id: that.sell_id
              }
            }).then(res => {
              console.log('update back', res);
            })
          } else {
            that.$axios.get(that.$url_prefix + 'setRegisterByName', {
              params: {
                name: value,
                finish: true
              }
            }).then(res => {
              console.log('update back', res);
            })
          }
        }
      },
      setRandom(e) {
        let that = this;
        let value = e.target.value;
        if (value) {
          e.target.value = '';
          e.target.blur();
          that.$axios.get(that.$url_prefix + 'updateRandom', {
            params: {
              name: value
            }
          }).then(res => {
            console.log('update back', res);
          })
        }
      },

      xhlxaaef() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'checkInvite', {
          params: {
            user_id: "600886",
            day: '2020-05-02'
          }
        }).then(res => {
          // 弄一个1分钟一个位置的数组
          let list = res.data.data;
          let result = [];
          for (let i = 0; i < list.length; i++) {
            let date = new Date(list[i].create_time);
            let min = date.getHours() * 60 + date.getMinutes();
            result[min] = (result[min] || 0) + 1;
            // if (result[min] > 5) {
            //   alert('超过5个了')
            // }
          }
          // result.length = 1440;
          // that.minutesList = result;
          result.forEach((value, index) => {
            if (value) {
              console.log(index + 1, value);
            }
          })
          console.log('update back', res);
        })
      },


      sehflalseh(area_name) {
        let that = this;
        let district = new AMap.DistrictSearch({
          // 返回行政区边界坐标等具体信息
          extensions: 'all',
          // 设置查询行政区级别为 区 
          level: 'district',
          city: '杭州市'
        })
        district.search(area_name, function (status, result) {
          console.log('result', result)
          let bounds = result.districtList[0].boundaries[0]
          let obj = {
            area_name: area_name,
            level: '区域',
            dots: bounds.map(x => x.lng + '|' + x.lat).join('-')
          }
          let param = {
            'db': 'WpAreaModel',
            'model': 'edit',
            'item': JSON.stringify(obj)
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
            console.log('update back', res);
          })
        })

      },

      xhxhfeefae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'locationByType', {
          params: {
            type: '商场',
            estate_id: '1wn7s8jl7vn'
          }
        }).then(res => {
          console.log('success', res);
        }).catch(err => {
          console.log('err', err);
        })
      },

      hfasefhxgae() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'matchEstateWithLand').then(res => {
          console.log('success', res);
        }).catch(err => {
          console.log('err', err);
        })
      },

      hxgfasefase() {
        let that = this;
        let obj = {
          name: '媒体看萧山',
          link: 'http://www.xiaoshan.gov.cn/col/col1302908/index.html',
        }
        let param = {
          'db': 'GovSiteModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          console.log('update back', res);
        })
      },
      hx8sefase() { // 
        let that = this;
        let obj = {
          name: '销售加分昵称对应',
          data: JSON.stringify({})
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
          console.log('update back', res);
        })
      },

      hlsehfsae() {
        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
        async function doSomething() {
          for (let i = 0; i < 5; i++) {
            console.log('i', i);
            await sleep(3000);
          }
        }
        // 运行试试
        doSomething()
      },

      xhlasefes() { // 固定标签
        let that = this;
        let data = ['地铁', '现房', '3万5以下', '闭眼摇']
        let obbj = { // 投资
          id: 'f9zs57gnxo',
          data: JSON.stringify(data)
        }
        let param = {
          'db': 'WpBackupModel',
          'model': 'edit',
          'item': JSON.stringify(obbj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('更新板块分类对象返回', res)
        }).catch(function (res) {
          console.log('更新板块分类对象失败', res)
        })
      },

      toJudgeSchool() { // 判断学区
        let that = this;
        that.$axios.get(that.$url_prefix + 'getSchoolArea').then(res => {
          that.$axios.get(that.$url_prefix + 'getEstateForSchool').then(back => {
            that.judgeSchool(res.data.data, back.data.newReals, back.data.oldReals);
          })
        })
      },
      judgeSchool(schools, newReals, oldReals) {
        let that = this;
        if (schools.length == 0) {
          console.log('over');
          return;
        }
        let theOne = schools.splice(0, 1)[0];
        let dots = JSON.parse(theOne.dots);
        for (let k = 0; k < dots.length; k++) {
          dots[k] = dots[k].map(x => x.split('|'));
        }

        // 新房
        let newIds = [];
        let ntp = 0; // 价格和
        let ntn = 0; // 有价格的数量
        let priceN = '';
        for (let i = 0; i < newReals.length; i++) {
          if (that.judgeOneSchool(dots, newReals[i].lnglat)) {
            newIds.push(newReals[i].id);
            let piece = newReals[i].piece || [];
            if (piece.length > 0) {
              piece.sort((a, b) => {
                return a.price - b.price;
              })
              ntp += parseInt(piece[0].price);
              ntn++;
            }
          }
        }
        if (ntn > 0) {
          priceN = (ntp / ntn).toFixed(0);
        }

        // 二手房
        let oldIds = [];
        let otp = 0; // 价格和
        let otn = 0; // 有价格的数量
        let priceO = '';
        for (let i = 0; i < oldReals.length; i++) {
          if (that.judgeOneSchool(dots, oldReals[i].lnglat)) {
            if (oldReals[i].price) {
              otp += parseInt(oldReals[i].price);
              otn++;
            }
            oldIds.push(oldReals[i].id);
          }
        }
        if (otn > 0) {
          priceO = (otp / otn).toFixed(0);
        }

        let obj = {
          id: theOne.id,
          insideN: newIds,
          insideO: oldIds,
          priceO: priceO,
          priceN: priceN
        }
        console.log('obj', obj);
        // that.judgeSchool(schools, newReals, oldReals);

        let param = {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          that.judgeSchool(schools, newReals, oldReals);
        }).catch(function (res) {
          console.log('fail', res);
          that.judgeSchool(schools, newReals, oldReals);
        })
      },
      judgeOneSchool(dots, lnglat) {
        let match = false;
        let pos = lnglat.split('-')[0].split('|');
        for (let i = 0; i < dots.length; i++) {
          if (AMap.GeometryUtil.isPointInRing(pos, dots[i])) {
            match = true;
            break;
          }
        }
        return match;
      },
      toBindSchool() { // 学区判断完后，在学区内但是没有绑定该学校的楼盘，要与学校绑定
        let that = this;
        that.$axios.get(that.$url_prefix + 'getAreaSchools').then(res => {
          console.log('res', res);
          that.schoolBindRealList = res.data.data;
          that.toBindReal();
        }).catch(err => {
          console.log('err', err);
        })
      },
      toBindReal() {
        let that = this;
        let list = that.schoolBindRealList;
        if (list.length === 0) {
          return;
        }
        let one = list.splice(0,1)[0];
        let realList = one.realList;
        delete one.realList;
        that.bindReal(realList, one.lnglat, one);
      },
      bindReal: async function (list, loc_lnglat, obj) {
        let that = this
        if (list.length === 0) {
          that.toBindReal();
          return;
        }
        let temp = list.splice(0, 1)[0];
        let location_data = await that.$planRoute(temp.lnglat, loc_lnglat);
        obj.real_estates.push(temp.id);
        that.$axios.post(that.$url_prefix + 'updateData', {
          'db': 'WpLocationModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }).then(function (res) {
          let path = {
            real_estate_id: temp.id,
            location_id: obj.id
          };
          path.location_data = location_data;
          that.$axios.post(that.$url_prefix + 'updateData', {
            'db': 'WpPathModel',
            'model': 'edit',
            'item': JSON.stringify(path)
          }).then(function (res) {
            that.bindReal(list, loc_lnglat, obj);
          }).catch(function (res) {
            console.log('上传路径失败', res)
          })
        }).catch(function (res) {
          console.log('上传地段失败', res)
        })
      },


      subwayNav(start_id, end_id) {
        let that = this;
        if (start_id == end_id) {
          return {
            steps: 0,
            change: 0,
            route: []
          }
        }

        let bias = 6; // 换乘的代价

        function samelines(lines1, lines2) {
          let result = [];
          let arr1 = lines1.split('|');
          let arr2 = lines2.split('|');
          arr1.forEach(x => {
            if (arr2.includes(x)) {
              result.push(x);
            }
          })
          return result;
        }

        function bestRoute(station1, station2) {
          let route = {
            from: station1.location_name,
            to: station2.location_name,
            steps: 9999
          };
          let lines = samelines(station1.subway_station, station2.subway_station);
          lines.forEach(x => {
            let stationList = subwayObj[x];
            if (stationList) {
              let start = stationList.findIndex(y => y.id == station1.id);
              let end = stationList.findIndex(y => y.id == station2.id);
              if (start > -1 && end > -1) {
                let steps = Math.abs(start - end);
                if (steps < route.steps) {
                  route.steps = steps;
                  route.line = x;
                }
              }
            }
          })
          return route;
        }

        let stations = that.stationList;
        let subwayObj = {}
        stations.forEach(x => {
          let lines = x.subway_station.split('|');
          lines.forEach(y => {
            if (!subwayObj[y]) {
              subwayObj[y] = [];
            }
            subwayObj[y].push(x);
          })
        })
        for (let key in subwayObj) {
          let list = subwayObj[key];
          if (list.length < 8) {
            delete subwayObj[key];
            continue;
          }
          let index = list.findIndex(x => {
            return x.start == key;
          });
          if (index > -1) {
            if (index > 0) {
              let temp = list[0];
              list[0] = list[index];
              list[index] = temp;
            }
            for (let i = 0; i < list.length - 2; i++) {
              let last = list[i];
              let minDis = null;
              let nexti = i + 1;
              let minIndex = -1;
              for (let j = nexti; j < list.length; j++) {
                let dis = that.getClosestDot(list[j].lnglat, last.lnglat).distance;
                if (!minDis || dis < minDis) {
                  minDis = dis;
                  minIndex = j;
                }
              }
              if (minIndex > nexti) {
                let tempj = list[nexti];
                list[nexti] = list[minIndex];
                list[minIndex] = tempj;
              }
            }
          } else {
            delete subwayObj[key];
          }
        }

        let matrix = [];
        let dis = [];
        let book = [];

        let start_index = null;
        let end_index = null;

        for (let i = 0; i < stations.length; i++) {
          matrix[i] = [];
          if (stations[i].id == start_id) {
            start_index = i;
          }
          if (stations[i].id == end_id) {
            end_index = i;
          }
          for (let k = 0; k < stations.length; k++) {
            matrix[i].push(bestRoute(stations[i], stations[k]));
          }
        }
        if (!start_index && start_index != 0) {
          return false;
        }
        if (!end_index && end_index != 0) {
          return false;
        }

        for (let i = 0; i < stations.length; i++) {
          book.push(0);
          dis.push({
            route: [matrix[start_index][i]],
            steps: matrix[start_index][i].steps
          })
        }
        book[0] = 1;

        let n = stations.length - 1;
        let u = 0;

        for (let i = 0; i < n; i++) {
          let min = {
            steps: 9999,
            route: []
          }
          for (let j = 0; j < n; j++) {
            if (book[j] == 0 && dis[j].steps < min.steps) {
              min = {
                steps: dis[j].steps,
                route: dis[j].route
              }
              u = j;
            }
          }
          book[u] = 1;

          for (let v = 0; v < n; v++) {
            if (matrix[u][v].steps <= 9999) {
              if (book[v] == 0 && dis[v].steps > (dis[u].steps + matrix[u][v].steps + bias)) {
                let a = dis[u].route.slice(0);
                a.push(matrix[u][v]);
                dis[v] = {
                  steps: dis[u].steps + matrix[u][v].steps,
                  route: a
                }
              }
            }
          }
        }

        let result = dis[end_index];
        let solution = {
          steps: result.steps,
          change: result.route.length - 1,
          route: []
        };
        let iserr = false;
        result.route.forEach(x => {
          if (x.steps == 9999) {
            iserr = true;
          }
          if (x.line == '机场轨道快线') {
            x.line = '机场线';
          }
          solution.route.push({
            type: 'station',
            name: x.from,
            line: x.line
          })
          solution.route.push({
            type: 'line',
            steps: x.steps
          })
        })
        if (iserr) {
          return false;
        }
        let last = result.route[result.route.length - 1];
        solution.route.push({
          type: 'station',
          name: last.to,
          line: last.line
        })

        return dis;

      },
      xlhlasefase() {
        let result = this.subwayNav('eq9p93tkk', '2je1b3ned20');
        console.log('result', result);
      },


      xhlahsefgaseh() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getOldReals').then(res => {
          
          let list = res.data.data.filter(x => {
            return !x.another_name;
          })
          console.log('res', list);
        })
      },

      xjgflgfise() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getCompany').then(res => {
          if (!that.placeSearch) {
            that.placeSearch = new AMap.PlaceSearch({
              city: '杭州',
              citylimit: true
            });
          }
          that.hxhfl9fae(res.data.data);
        }).catch(err => {
          console.log('get companys fail', err);
        });
      },
      hxhfl9fae(list) {
        let that = this;
        if (list.length == 0) {
          // that.xjgflgfise();
          return;
        }
        let one = list.splice(0,1)[0];
        
        that.placeSearch.search(one.reg_addr, function (status, result) {
          if (status === 'complete') {
            let temp = result.poiList.pois[0];
            let lnglat = temp.location.lng + '|' + temp.location.lat;
            let obj = {
              _id: one._id,
              lnglat: lnglat
            }
            let param = {
              'db': 'CompanyModel',
              'model': 'edit',
              'item': JSON.stringify(obj),
            }
            that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
              console.log('lnglat', lnglat);
              that.hxhfl9fae(list);
            }).catch(function (res) {
              console.log('fail', res);
              that.hxhfl9fae(list);
            })
          } else {
            console.log('placeSearch.search fail', one, status, result);
            let obj = {
              _id: one._id,
              lnglat: '暂无'
            }
            let param = {
              'db': 'CompanyModel',
              'model': 'edit',
              'item': JSON.stringify(obj),
            }
            that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
              that.hxhfl9fae(list);
            }).catch(function (res) {
              console.log('fail', res);
              that.hxhfl9fae(list);
            })
          }
        })
      },
      searchMap(adr) {
        return new Promise((resolve,reject) => {
          let placeSearch = new AMap.PlaceSearch({
            city: '杭州',
            citylimit: true
          });
          placeSearch.search(adr, function (status, result) {
            if (status === 'complete') {
              resolve(result.poiList.pois);
            }
          })
        })
      },

      addManageUser() {
        let that = this;
        that.$axios.post(that.$url_prefix + 'addManageUser', {
          username: that.userName,
          password: that.passwd,
          userType: that.userType,
          fullName: that.fullName,
          group: that.group,
          userCity: that.userCity,
          phone: that.phone,
          phonex: that.phonex,
          mp_uid: that.mp_uid,
          project: that.project,
          client: that.client,
        }).then(res => {
          console.log('add back', res);
          if (Array.isArray(res.data.data)) {
            that.backUsers = res.data.data;
          }
        }).catch(err => {
          console.log('add fail', err);
        })
      }

    }
  }

</script>

<style scoped>
  img {
    height: 100px;
    width: 100px;
  }

  .sales {
    display: flex;
    flex-wrap: wrap;
  }

  .sale {
    margin: 20px;
    width: 200px;
    line-height: 20px;
  }

  .colorline {
    width: 1200px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/page/debug.vue